/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 8512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  "gameName": {
    "state": {
      "beta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    },
    "text": {
      "1ma": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "1pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "1wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "2pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "2qf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "2qm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "2wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "3pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "3ro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "3wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "3wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "4pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "ams": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "bel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "bgm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "bi2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "bil": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "bub": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "bus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "bux": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "bwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "cpt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "cpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "ctc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "dar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "dko": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "drg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "emq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "flu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "fr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "fre": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "fuq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "gol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "gos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "hid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "hts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "jet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "jj2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "jt2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "jw2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "jwl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "kdo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "kla": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "kno": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "lab": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "maf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "mag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "mah": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "mat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "mau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "mbs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "mdn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "mjj": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "mpp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "mps": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "mpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "mus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "oly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "pbx": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "pfm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "pmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "pol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "prt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "py2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "pyr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "qbu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "qui": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "rom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "rsq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "ruk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "rum": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "s2i": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "s2l": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "s2p": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "sdk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "sen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "sh2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "ska": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "so2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "so3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "soh": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "sol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "spi": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "spl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "spp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "spq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "sss": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "swp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "tar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "tau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "tr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "trv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "wiz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "wmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "wn4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "wob": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "wos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "xwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "yaz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "zoo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    }
  },
  "notification": {
    "award": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    },
    "gameNight": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    },
    "lowMoney": {
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    },
    "newsletter": {
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    }
  }
});

/***/ }),

/***/ 4506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  "gameName": {
    "state": {
      "beta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(Beta)"])},
      "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(New)"])}
    },
    "text": {
      "1ma": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crazy Eights"])},
      "1pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "1wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "2pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "2qf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fútbol Quiz"])},
      "2qm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz-Mundial"])},
      "2wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "3pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "3ro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rami"])},
      "3wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "3wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "4pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "ams": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fossil Fever"])},
      "bel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belote"])},
      "bgm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Backgammon"])},
      "bi2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball Solo"])},
      "bil": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball solo"])},
      "bub": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Popp"])},
      "bus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Speed"])},
      "bux": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Deluxe"])},
      "bwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bookworm"])},
      "cpt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kaptajn Klik"])},
      "cpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kleopatras pyramide"])},
      "ctc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Capt'n Torch"])},
      "dar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DartKing"])},
      "dko": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doppelkopf"])},
      "drg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dragon Click"])},
      "emq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EM-Quiz"])},
      "flu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fluffy"])},
      "fr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fre": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fuq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fussball-­Quiz"])},
      "gol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GoldRush"])},
      "gos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ghost­Sweeper"])},
      "hid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skattesøger"])},
      "hts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hearts"])},
      "jet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jetrip"])},
      "jj2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jungle Jewels 2"])},
      "jt2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Space Trip"])},
      "jw2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jewel Splash"])},
      "jwl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jungle Jewels"])},
      "kdo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olympens Kugler"])},
      "kla": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaverjassen"])},
      "kno": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roll 5"])},
      "lab": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animal Maze"])},
      "maf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong Flowers"])},
      "mag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magnoid"])},
      "mah": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong"])},
      "mat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong 2"])},
      "mau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crazy Eights"])},
      "mbs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Balloon Blast"])},
      "mdn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Razzle-Dazzle"])},
      "mjj": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potion Panic"])},
      "mpp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["8-Ball Pool"])},
      "mps": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maya Whiz"])},
      "mpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maya Pyramide"])},
      "mus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mus"])},
      "oly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olympia-­Quiz"])},
      "pbx": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Puzzle Garden"])},
      "pfm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "pmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promi-Quiz"])},
      "pol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Polar Stars"])},
      "prt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pirate Ships"])},
      "py2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramide2"])},
      "pyr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramide"])},
      "qbu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Q-Bust"])},
      "qui": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz"])},
      "rom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rommé"])},
      "rsq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reise-Quiz"])},
      "ruk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Okey"])},
      "rum": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grand Gin Rummy"])},
      "s2i": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "s2l": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Light"])},
      "s2p": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "sdk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sudoku Domino"])},
      "sen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lame Duck"])},
      "sh2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmony"])},
      "ska": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skat"])},
      "so2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire2"])},
      "so3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire"])},
      "soh": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmony"])},
      "sol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire"])},
      "spi": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "spl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Light"])},
      "spp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "spq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sport-Quiz"])},
      "sss": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sechsundsechzig"])},
      "swp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sweepa"])},
      "tar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tarot"])},
      "tau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bytterus"])},
      "tr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FodboldFlip"])},
      "trv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trivia Quiz"])},
      "wiz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oh Hell"])},
      "wmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WM-Quiz"])},
      "wn4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["4 Stribe"])},
      "wob": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "wos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "xwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["XrossWord"])},
      "yaz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roll 5"])},
      "zoo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zoo 21"])}
    }
  },
  "notification": {
    "award": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indsæt nu"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nye awards!"])}
    },
    "gameNight": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To the lobby"])},
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Today we’re playing “", _interpolate(_named("gameName")), "”! Let's go!"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["It's game night!"])}
    },
    "lowMoney": {
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["### Information\n\nDu har mindre end ", _interpolate(_named("threshold")), " din spillekonto. Oplad [din konto](#) nu for at spille videre!"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Information"])}
    },
    "newsletter": {
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["### Dit nyhedsbrev\n\nHold dig opdateret nemt og bekvemt via e-mail. Læs mere om vores **nye spil** og deltag i **sjove konkurrencer**.\n\n<button>Tilmeld dig nu</button>"])}
    }
  }
});

/***/ }),

/***/ 8806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  "gameName": {
    "state": {
      "beta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(Beta)"])},
      "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(Neu)"])}
    },
    "text": {
      "1ma": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crazy Eights"])},
      "1pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Maus"])},
      "1wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wortgefecht"])},
      "2pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Maus"])},
      "2qf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fútbol Quiz"])},
      "2qm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz-Mundial"])},
      "2wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "3pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Maus"])},
      "3ro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rami"])},
      "3wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wortgefecht"])},
      "3wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "4pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Maus"])},
      "ams": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fossil Fever"])},
      "bel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belote"])},
      "bgm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Backgammon"])},
      "bi2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball Solo"])},
      "bil": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball Solo"])},
      "bub": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Popp"])},
      "bus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Speed"])},
      "bux": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Deluxe"])},
      "bwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bookworm"])},
      "cpt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käpt'n Klick"])},
      "cpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kleopatras Pyramide"])},
      "ctc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Capt'n Torch"])},
      "dar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DartKing"])},
      "dko": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doppelkopf"])},
      "drg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dragon Click"])},
      "emq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EM-Quiz"])},
      "flu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fluffy"])},
      "fr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fre": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fuq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fußball-Quiz"])},
      "gol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GoldRush"])},
      "gos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ghost-Sweeper"])},
      "hid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sammel­surium"])},
      "hts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hearts"])},
      "jet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jetrip"])},
      "jj2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jungle Jewels 2"])},
      "jt2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Space Trip"])},
      "jw2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jewel Splash"])},
      "jwl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jungle Jewels"])},
      "kdo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kugeln des Olymp"])},
      "kla": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaverjassen"])},
      "kno": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Knobeln"])},
      "lab": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgeheckt!"])},
      "maf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong Flowers"])},
      "mag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magnoid"])},
      "mah": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MahJongg"])},
      "mat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong 2"])},
      "mau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Miau"])},
      "mbs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Balloon Blast"])},
      "mdn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Au Weia!"])},
      "mjj": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hexen­kessel"])},
      "mpp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["8-Ball Billard"])},
      "mps": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maya Whiz"])},
      "mpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maya Pyramide"])},
      "mus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mus"])},
      "oly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olympia-­Quiz"])},
      "pbx": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Puzzle Garden"])},
      "pfm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Maus"])},
      "pmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promi-Quiz"])},
      "pol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Polar Stars"])},
      "prt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Piraten versenken"])},
      "py2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramide2"])},
      "pyr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramide"])},
      "qbu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Q-Bust"])},
      "qui": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz"])},
      "rom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rommé"])},
      "rsq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reise-Quiz"])},
      "ruk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Räuber-​Rommé"])},
      "rum": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grand Gin Rummy"])},
      "s2i": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "s2l": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Light"])},
      "s2p": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "sdk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sudoku Domino"])},
      "sen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lahme Ente"])},
      "sh2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmony"])},
      "ska": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skat"])},
      "so2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire"])},
      "so3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire"])},
      "soh": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmony"])},
      "sol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Klassik"])},
      "spi": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "spl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Light"])},
      "spp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "spq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sport-Quiz"])},
      "sss": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["66 / Schnapsen"])},
      "swp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sweepa"])},
      "tar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tarot"])},
      "tau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tausch­Rausch"])},
      "tr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fußball­Match"])},
      "trv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trivia Quiz"])},
      "wiz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sticheln"])},
      "wmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WM-Quiz"])},
      "wn4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Win 4"])},
      "wob": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wortgefecht"])},
      "wos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "xwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kreuzwort­rätsel"])},
      "yaz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Knobeln"])},
      "zoo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zoo 21"])}
    }
  },
  "notification": {
    "award": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jetzt einkleben"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neue Auszeichnung!"])}
    },
    "gameNight": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zur Lobby"])},
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Heute wird „", _interpolate(_named("gameName")), "“ gespielt! Auf geht‘s!"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Es ist Spieleabend!"])}
    },
    "lowMoney": {
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["### Konto aufladen\n\nIhr Kontostand beträgt weniger als ", _interpolate(_named("threshold")), ". Laden Sie jetzt schnell [Ihr Konto](#) auf und spielen Sie weiter!"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto aufladen"])}
    },
    "newsletter": {
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["### Ihr Newsletter\n\nInformieren Sie sich ganz leicht und bequem per E-Mail über alle **neuen Spiele** und nehmen Sie an **tollen Gewinnspielen** teil.\n\n<button>Jetzt anmelden</button>"])}
    }
  }
});

/***/ }),

/***/ 2088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  "gameName": {
    "state": {
      "beta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(Beta)"])},
      "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(New)"])}
    },
    "text": {
      "1ma": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crazy Eights"])},
      "1pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "1wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "2pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "2qf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fútbol Quiz"])},
      "2qm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz-Mundial"])},
      "2wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "3pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "3ro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rami"])},
      "3wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "3wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "4pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "ams": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fossil Fever"])},
      "bel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belote"])},
      "bgm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Backgammon"])},
      "bi2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball Billard solo"])},
      "bil": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball Solo"])},
      "bub": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Popp"])},
      "bus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Speed"])},
      "bux": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Deluxe"])},
      "bwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bookworm"])},
      "cpt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Captain Click"])},
      "cpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cleopatra's Pyramid"])},
      "ctc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Capt'n Torch"])},
      "dar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DartKing"])},
      "dko": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doppelkopf"])},
      "drg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dragon Click"])},
      "emq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EM-Quiz"])},
      "flu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fluffy"])},
      "fr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fre": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fuq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fussball-‌Quiz"])},
      "gol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GoldRush"])},
      "gos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ghost‌Sweeper"])},
      "hid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hidden Gizmos"])},
      "hts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hearts"])},
      "jet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jetrip"])},
      "jj2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jungle Jewels 2"])},
      "jt2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Space Trip"])},
      "jw2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jewel Splash"])},
      "jwl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jungle Jewels"])},
      "kdo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marbles of Olympus"])},
      "kla": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaverjassen"])},
      "kno": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roll 5"])},
      "lab": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animal Maze"])},
      "maf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong Flowers"])},
      "mag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magnoid"])},
      "mah": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MahJong"])},
      "mat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong 2"])},
      "mau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crazy Eights"])},
      "mbs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Balloon Blast"])},
      "mdn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Razzle-Dazzle"])},
      "mjj": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potion Panic"])},
      "mpp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["8-Ball Pool"])},
      "mps": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maya Whiz"])},
      "mpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maya Pyramid"])},
      "mus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mus"])},
      "oly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olympia-‌Quiz"])},
      "pbx": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Puzzle Garden"])},
      "pfm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profess-or Mouse"])},
      "pmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promi-Quiz"])},
      "pol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Polar Stars"])},
      "prt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pirate Ships"])},
      "py2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramide2"])},
      "pyr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramid"])},
      "qbu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Q-Bust"])},
      "qui": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz"])},
      "rom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rummy"])},
      "rsq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reise-Quiz"])},
      "ruk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Okey"])},
      "rum": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grand Gin Rummy"])},
      "s2i": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "s2l": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Light"])},
      "s2p": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "sdk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sudoku Domino"])},
      "sen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lame Duck"])},
      "sh2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmony"])},
      "ska": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skat"])},
      "so2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire"])},
      "so3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire"])},
      "soh": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmony"])},
      "sol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire classic"])},
      "spi": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "spl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Light"])},
      "spp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "spq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sport-Quiz"])},
      "sss": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sechsundsechzig"])},
      "swp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sweepa"])},
      "tar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tarot"])},
      "tau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Combina"])},
      "tr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Football Match"])},
      "trv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trivia Quiz"])},
      "wiz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oh Hell"])},
      "wmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WM-Quiz"])},
      "wn4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Match 4"])},
      "wob": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "wos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "xwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["XrossWord"])},
      "yaz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roll 5"])},
      "zoo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zoo 21"])}
    }
  },
  "notification": {
    "award": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Place sticker now"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New award!"])}
    },
    "gameNight": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To the lobby"])},
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Today we’re playing “", _interpolate(_named("gameName")), "”! Let's go!"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["It's game night!"])}
    },
    "lowMoney": {
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["### Information\n\nYour account balance is less than ", _interpolate(_named("threshold")), ". Charge [your account](#) now to continue to play great games for money."])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Information"])}
    },
    "newsletter": {
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["### Your newsletter\n\nGet the latest news on all **new games** quickly and easily via email and participate in our **fun competitions**.\n\n<button>Sign up now</button>"])}
    }
  }
});

/***/ }),

/***/ 5723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  "gameName": {
    "state": {
      "beta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(Beta)"])},
      "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(New)"])}
    },
    "text": {
      "1ma": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crazy Eights"])},
      "1pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "1wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "2pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "2qf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fútbol Quiz"])},
      "2qm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz-Mundial"])},
      "2wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "3pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "3ro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rami"])},
      "3wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "3wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "4pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "ams": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fossil Fever"])},
      "bel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belote"])},
      "bgm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Backgammon"])},
      "bi2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball Billard solo"])},
      "bil": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball Solo"])},
      "bub": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Popp"])},
      "bus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Speed"])},
      "bux": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Deluxe"])},
      "bwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bookworm"])},
      "cpt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Captain Click"])},
      "cpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cleopatra's Pyramid"])},
      "ctc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Capt'n Torch"])},
      "dar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DartKing"])},
      "dko": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doppelkopf"])},
      "drg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dragon Click"])},
      "emq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EM-Quiz"])},
      "flu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fluffy"])},
      "fr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fre": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fuq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fussball-‌Quiz"])},
      "gol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GoldRush"])},
      "gos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ghost‌Sweeper"])},
      "hid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hidden Gizmos"])},
      "hts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hearts"])},
      "jet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jetrip"])},
      "jj2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jungle Jewels 2"])},
      "jt2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Space Trip"])},
      "jw2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jewel Splash"])},
      "jwl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jungle Jewels"])},
      "kdo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marbles of Olympus"])},
      "kla": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaverjassen"])},
      "kno": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roll 5"])},
      "lab": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animal Maze"])},
      "maf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong Flowers"])},
      "mag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magnoid"])},
      "mah": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MahJong"])},
      "mat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong 2"])},
      "mau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crazy Eights"])},
      "mbs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Balloon Blast"])},
      "mdn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Razzle-Dazzle"])},
      "mjj": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potion Panic"])},
      "mpp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["8-Ball Pool"])},
      "mps": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maya Whiz"])},
      "mpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maya Pyramid"])},
      "mus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mus"])},
      "oly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olympia-‌Quiz"])},
      "pbx": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Puzzle Garden"])},
      "pfm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profess-or Mouse"])},
      "pmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promi-Quiz"])},
      "pol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Polar Stars"])},
      "prt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pirate Ships"])},
      "py2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramide2"])},
      "pyr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramid"])},
      "qbu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Q-Bust"])},
      "qui": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz"])},
      "rom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rummy"])},
      "rsq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reise-Quiz"])},
      "ruk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Okey"])},
      "rum": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grand Gin Rummy"])},
      "s2i": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "s2l": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Light"])},
      "s2p": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "sdk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sudoku Domino"])},
      "sen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lame Duck"])},
      "sh2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmony"])},
      "ska": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skat"])},
      "so2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire"])},
      "so3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire"])},
      "soh": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmony"])},
      "sol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire classic"])},
      "spi": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "spl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Light"])},
      "spp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "spq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sport-Quiz"])},
      "sss": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sechsundsechzig"])},
      "swp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sweepa"])},
      "tar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tarot"])},
      "tau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Combina"])},
      "tr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Football Match"])},
      "trv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trivia Quiz"])},
      "wiz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oh Hell"])},
      "wmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WM-Quiz"])},
      "wn4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Match 4"])},
      "wob": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "wos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "xwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["XrossWord"])},
      "yaz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roll 5"])},
      "zoo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zoo 21"])}
    }
  },
  "notification": {
    "award": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Place sticker now"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New award!"])}
    },
    "gameNight": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To the lobby"])},
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Today we’re playing “", _interpolate(_named("gameName")), "”! Let's go!"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["It's game night!"])}
    },
    "lowMoney": {
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["### Information\n\nYour account balance is less than ", _interpolate(_named("threshold")), ". Charge [your account](#) now to continue to play great games for money."])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Information"])}
    },
    "newsletter": {
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["### Your newsletter\n\nGet the latest news on all **new games** quickly and easily via email and participate in our **fun competitions**.\n\n<button>Sign up now</button>"])}
    }
  }
});

/***/ }),

/***/ 7875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  "gameName": {
    "state": {
      "beta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(Beta)"])},
      "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(New)"])}
    },
    "text": {
      "1ma": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crazy Eights"])},
      "1pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profesor Mouse"])},
      "1wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "2pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profesor Mouse"])},
      "2qf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fútbol Quiz"])},
      "2qm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz-Mundial"])},
      "2wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "3pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profesor Mouse"])},
      "3ro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rami"])},
      "3wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "3wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "4pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profesor Mouse"])},
      "ams": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fossil Fever"])},
      "bel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belote"])},
      "bgm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Backgammon"])},
      "bi2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball Solo"])},
      "bil": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bola 9 Desafío"])},
      "bub": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Popp"])},
      "bus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Speed"])},
      "bux": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Deluxe"])},
      "bwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bookworm"])},
      "cpt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Capitán Click"])},
      "cpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pirámide de Cleopatra"])},
      "ctc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Capt'n Torch"])},
      "dar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DartKing"])},
      "dko": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doppelkopf"])},
      "drg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dragon Click"])},
      "emq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EM-Quiz"])},
      "flu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fluffy"])},
      "fr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fre": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fuq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fussball-­Quiz"])},
      "gol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GoldRush"])},
      "gos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ghost­Sweeper"])},
      "hid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trotamundos"])},
      "hts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Corazones"])},
      "jet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jetrip"])},
      "jj2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jungle Jewels 2"])},
      "jt2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Space Trip"])},
      "jw2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jewel Splash"])},
      "jwl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Joyas de la Jungla"])},
      "kdo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Esferas del Olimpo"])},
      "kla": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaverjassen"])},
      "kno": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generala"])},
      "lab": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animal Maze"])},
      "maf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MahJongg Flowers"])},
      "mag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magnoid"])},
      "mah": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MahJongg"])},
      "mat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong 2"])},
      "mau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pumba"])},
      "mbs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Balloon Blast"])},
      "mdn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Picaresca"])},
      "mjj": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potion Panic"])},
      "mpp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Billar 8 Bolas"])},
      "mps": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maya Whiz"])},
      "mpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pirámide Maya"])},
      "mus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mus"])},
      "oly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olympia-­Quiz"])},
      "pbx": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Puzzle Garden"])},
      "pfm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profesor Mouse"])},
      "pmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promi-Quiz"])},
      "pol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Polar Stars"])},
      "prt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abordaje Pirata"])},
      "py2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramide2"])},
      "pyr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pirámide"])},
      "qbu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Q-Bust"])},
      "qui": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz"])},
      "rom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rommé"])},
      "rsq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reise-Quiz"])},
      "ruk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Okey"])},
      "rum": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grand Gin Rummy"])},
      "s2i": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "s2l": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Light"])},
      "s2p": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "sdk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sudoku"])},
      "sen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lame Duck"])},
      "sh2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmony"])},
      "ska": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skat"])},
      "so2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitario"])},
      "so3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire"])},
      "soh": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitario Harmony"])},
      "sol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitario clásico"])},
      "spi": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "spl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Light"])},
      "spp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "spq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sport-Quiz"])},
      "sss": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sechsundsechzig"])},
      "swp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sweepa"])},
      "tar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tarot"])},
      "tau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Combina"])},
      "tr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tiki Taka"])},
      "trv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trivia Quiz"])},
      "wiz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pocha Magic"])},
      "wmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WM-Quiz"])},
      "wn4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["4 en Línea"])},
      "wob": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "wos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "xwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["XrossWord"])},
      "yaz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generala"])},
      "zoo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zoo 21"])}
    }
  },
  "notification": {
    "award": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pégala ahora"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡Nueva condecoración!"])}
    },
    "gameNight": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To the lobby"])},
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Today we’re playing “", _interpolate(_named("gameName")), "”! Let's go!"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["It's game night!"])}
    },
    "lowMoney": {
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["### Información\n\nTu cuenta dispone de menos de  ", _interpolate(_named("threshold")), " de saldo. [¡Recárgala](#) y sigue jugando!"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Información"])}
    },
    "newsletter": {
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["### Tu newsletter\n\nLa newsletter te informa sobre **todas las noticias** y **promociones** de GameDuell.\n\n<button>Regístrate ahora</button>"])}
    }
  }
});

/***/ }),

/***/ 8026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  "gameName": {
    "state": {
      "beta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(Beta)"])},
      "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(New)"])}
    },
    "text": {
      "1ma": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le 8 américain"])},
      "1pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professeur Mulot"])},
      "1wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mots mêlés"])},
      "2pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professeur Mulot"])},
      "2qf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fútbol Quiz"])},
      "2qm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz-Mundial"])},
      "2wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Énigme de la Fortune"])},
      "3pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professeur Mulot"])},
      "3ro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rami"])},
      "3wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mots mêlés"])},
      "3wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Énigme de la Fortune"])},
      "4pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professeur Mulot"])},
      "ams": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fossile Mania"])},
      "bel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belote"])},
      "bgm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Backgammon"])},
      "bi2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball Solo"])},
      "bil": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jeu de la 9 solo"])},
      "bub": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aquabulle"])},
      "bus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapidbulles"])},
      "bux": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bulles Deluxe"])},
      "bwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bookworm"])},
      "cpt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Capt'n Clic"])},
      "cpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramide de Cléopâtre"])},
      "ctc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Capt'n Torche"])},
      "dar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fléchettes"])},
      "dko": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doppelkopf"])},
      "drg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dragon Clic"])},
      "emq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EM-Quiz"])},
      "flu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fluffy"])},
      "fr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fre": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fuq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fussball-­Quiz"])},
      "gol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GoldRush"])},
      "gos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ghost­Sweeper"])},
      "hid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bric-à-Brac"])},
      "hts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dame de Pique"])},
      "jet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jetrip"])},
      "jj2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jungle Jewels 2"])},
      "jt2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Space Trip"])},
      "jw2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Joyaux Express"])},
      "jwl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Joyaux"])},
      "kdo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sphères de l'Olympe"])},
      "kla": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaverjassen"])},
      "kno": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yams"])},
      "lab": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LabyQuest"])},
      "maf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pékin Fleurs"])},
      "mag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Casse-Brique"])},
      "mah": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pékin"])},
      "mat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong 2"])},
      "mau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le 8 américain"])},
      "mbs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Circus Mania"])},
      "mdn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saute qui peut !"])},
      "mjj": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Duel de Sorciers"])},
      "mpp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jeu de la 8"])},
      "mps": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maya Whiz"])},
      "mpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramide Maya"])},
      "mus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mus"])},
      "oly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olympia-­Quiz"])},
      "pbx": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mon Potager"])},
      "pfm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professeur Mulot"])},
      "pmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promi-Quiz"])},
      "pol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pôle Stars"])},
      "prt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bataille des Pirates"])},
      "py2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramide2"])},
      "pyr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramide"])},
      "qbu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Q-Bust"])},
      "qui": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz"])},
      "rom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rami"])},
      "rsq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reise-Quiz"])},
      "ruk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ramikubic"])},
      "rum": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grand Gin Rummy"])},
      "s2i": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "s2l": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider débutant"])},
      "s2p": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "sdk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sudoku Domino"])},
      "sen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Canard boiteux"])},
      "sh2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmonie"])},
      "ska": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skat"])},
      "so2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire"])},
      "so3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire"])},
      "soh": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmonie"])},
      "sol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire classique"])},
      "spi": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "spl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider débutant"])},
      "spp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "spq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sport-Quiz"])},
      "sss": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sechsundsechzig"])},
      "swp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sweepa"])},
      "tar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tarot"])},
      "tau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Combina"])},
      "tr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Combifoot"])},
      "trv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trivia Quiz"])},
      "wiz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La Grimpette"])},
      "wmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WM-Quiz"])},
      "wn4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["4 à la suite"])},
      "wob": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mots mêlés"])},
      "wos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Énigme de la Fortune"])},
      "xwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["XrossWord"])},
      "yaz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yams"])},
      "zoo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zoo 21"])}
    }
  },
  "notification": {
    "award": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Coller maintenant"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveau trophée !"])}
    },
    "gameNight": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accès au Lobby"])},
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aujourd'hui nous jouons à \"", _interpolate(_named("gameName")), "\" ! C'est parti !"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La soirée Jeux GameDuell !"])}
    },
    "lowMoney": {
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["### Info\n\nVotre solde est inférieur à ", _interpolate(_named("threshold")), ". Alimentez vite [votre compte](#) pour plus de fun sur GameDuell !"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Info"])}
    },
    "newsletter": {
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["### Newsletter GameDuell\n\nInformez-vous tranquillement par e-mail sur tous les **nouveaux jeux** et participez à des **super jeux concours**.\n\n<button>Souscrire maintenant</button>"])}
    }
  }
});

/***/ }),

/***/ 5185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  "gameName": {
    "state": {
      "beta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(Beta)"])},
      "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(New)"])}
    },
    "text": {
      "1ma": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pesten"])},
      "1pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Muis"])},
      "1wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "2pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Muis"])},
      "2qf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fútbol Quiz"])},
      "2qm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz-Mundial"])},
      "2wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Show"])},
      "3pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Muis"])},
      "3ro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rami"])},
      "3wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "3wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Show"])},
      "4pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Muis"])},
      "ams": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fossil Fever"])},
      "bel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belote"])},
      "bgm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Backgammon"])},
      "bi2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball Solo"])},
      "bil": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball solo"])},
      "bub": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Popp"])},
      "bus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Speed"])},
      "bux": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Deluxe"])},
      "bwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bookworm"])},
      "cpt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kap´tein Klik"])},
      "cpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cleopatra's Piramide"])},
      "ctc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Capt'n Torch"])},
      "dar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DartKing"])},
      "dko": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doppelkopf"])},
      "drg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dragon Click"])},
      "emq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EM-Quiz"])},
      "flu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fluffy"])},
      "fr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fre": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Freecell"])},
      "fuq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fussball-­Quiz"])},
      "gol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GoldRush"])},
      "gos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ghost­sweeper"])},
      "hid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spot de spullen"])},
      "hts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hartenjagen"])},
      "jet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jetrip"])},
      "jj2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jungle Jewels 2"])},
      "jt2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Space Trip"])},
      "jw2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jewel Splash"])},
      "jwl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jungle Jewels"])},
      "kdo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parels van Olympus"])},
      "kla": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaverjassen"])},
      "kno": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dobbelen"])},
      "lab": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animal Maze"])},
      "maf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong flowers"])},
      "mag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magnoid"])},
      "mah": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong"])},
      "mat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong 2"])},
      "mau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pesten"])},
      "mbs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Balloon Blast"])},
      "mdn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Razzle-Dazzle"])},
      "mjj": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potion Panic"])},
      "mpp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["8-Ball Pool"])},
      "mps": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maya Whiz"])},
      "mpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maya Piramide"])},
      "mus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mus"])},
      "oly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olympia-­Quiz"])},
      "pbx": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Puzzle Garden"])},
      "pfm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Muis"])},
      "pmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promi-Quiz"])},
      "pol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Polar Stars"])},
      "prt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Piraten Zeeslag"])},
      "py2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramide2"])},
      "pyr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Piramide"])},
      "qbu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Q-bust"])},
      "qui": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz"])},
      "rom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rummi"])},
      "rsq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reise-Quiz"])},
      "ruk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Okey"])},
      "rum": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grand Gin Rummy"])},
      "s2i": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "s2l": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Light"])},
      "s2p": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "sdk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sudoku"])},
      "sen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lame Duck"])},
      "sh2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmony"])},
      "ska": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skat"])},
      "so2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patience"])},
      "so3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patience"])},
      "soh": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmony"])},
      "sol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patience klassiek"])},
      "spi": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "spl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Light"])},
      "spp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider pro"])},
      "spq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sport-Quiz"])},
      "sss": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sechsundsechzig"])},
      "swp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sweepa"])},
      "tar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tarot"])},
      "tau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Combina"])},
      "tr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voetbal Mania"])},
      "trv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trivia Quiz"])},
      "wiz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wizzy"])},
      "wmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WM-Quiz"])},
      "wn4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["4 wint"])},
      "wob": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "wos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Show"])},
      "xwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["XrossWord"])},
      "yaz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dobbelen"])},
      "zoo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zoo 21"])}
    }
  },
  "notification": {
    "award": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nu inplakken"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nieuwe trofee!"])}
    },
    "gameNight": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naar de lobby"])},
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Vandaag spelen we „", _interpolate(_named("gameName")), "“! We zijn er klaar voor!"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spelletjesavond!\n"])}
    },
    "lowMoney": {
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["### Let op\n\nUw saldo is lager dan ", _interpolate(_named("threshold")), ". Laad hier nu snel [uw speleraccount](#) op en speel verder!"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Let op"])}
    },
    "newsletter": {
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["### Uw Newsletter\n\nInformeer u eenvoudig en gemakkelijk per e-mail over alle **nieuwe spellen** en neem deel aan **leuke wedstrijden**.\n\n<button>Nu aanmelden</button>"])}
    }
  }
});

/***/ }),

/***/ 2469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  "gameName": {
    "state": {
      "beta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(Beta)"])},
      "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(New)"])}
    },
    "text": {
      "1ma": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crazy Eights"])},
      "1pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "1wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "2pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "2qf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fútbol Quiz"])},
      "2qm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz-Mundial"])},
      "2wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "3pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "3ro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rami"])},
      "3wb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "3wo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "4pf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "ams": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fossil Fever"])},
      "bel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belote"])},
      "bgm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Backgammon"])},
      "bi2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball Solo"])},
      "bil": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball solo"])},
      "bub": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Popp"])},
      "bus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Speed"])},
      "bux": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bubble Deluxe"])},
      "bwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bookworm"])},
      "cpt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kapten Klick"])},
      "cpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kleopatras Pyramid"])},
      "ctc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Capt'n Torch"])},
      "dar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DartKing"])},
      "dko": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Doppelkopf"])},
      "drg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dragon Click"])},
      "emq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EM-Quiz"])},
      "flu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fluffy"])},
      "fr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fre": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FreeCell"])},
      "fuq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fussball-­Quiz"])},
      "gol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GoldRush"])},
      "gos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ghost­Sweeper"])},
      "hid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skattsökare"])},
      "hts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hearts"])},
      "jet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jetrip"])},
      "jj2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jungle Jewels 2"])},
      "jt2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Space Trip"])},
      "jw2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jewel Splash"])},
      "jwl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Djungel Juveler"])},
      "kdo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olympens klot"])},
      "kla": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaverjassen"])},
      "kno": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roll 5"])},
      "lab": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animal Maze"])},
      "maf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong Flowers"])},
      "mag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magnoid"])},
      "mah": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MahJongg"])},
      "mat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mahjong 2"])},
      "mau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crazy Eights"])},
      "mbs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Balloon Blast"])},
      "mdn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Razzle-Dazzle"])},
      "mjj": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potion Panic"])},
      "mpp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["8-Ball Pool"])},
      "mps": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maya Whiz"])},
      "mpy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maya Pyramid"])},
      "mus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mus"])},
      "oly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olympia-­Quiz"])},
      "pbx": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Puzzle Garden"])},
      "pfm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Professor Mouse"])},
      "pmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promi-Quiz"])},
      "pol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Polar Stars"])},
      "prt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sänka Pirater"])},
      "py2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["9-Ball Solo"])},
      "pyr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pyramid"])},
      "qbu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Q-Bust"])},
      "qui": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quiz"])},
      "rom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rommé"])},
      "rsq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reise-Quiz"])},
      "ruk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Okey"])},
      "rum": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grand Gin Rummy"])},
      "s2i": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "s2l": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Light"])},
      "s2p": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "sdk": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sudoku Domino"])},
      "sen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lame Duck"])},
      "sh2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmony"])},
      "ska": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skat"])},
      "so2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire"])},
      "so3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire"])},
      "soh": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire Harmony"])},
      "sol": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solitaire klassisk"])},
      "spi": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider"])},
      "spl": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Light"])},
      "spp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spider Pro"])},
      "spq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sport-Quiz"])},
      "sss": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sechsundsechzig"])},
      "swp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sweepa"])},
      "tar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tarot"])},
      "tau": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Combina"])},
      "tr2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FotbollFlip"])},
      "trv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trivia Quiz"])},
      "wiz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plump"])},
      "wmq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WM-Quiz"])},
      "wn4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["4 på en rad"])},
      "wob": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Word Twist"])},
      "wos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WordShow"])},
      "xwo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["XrossWord"])},
      "yaz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roll 5"])},
      "zoo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zoo 21"])}
    }
  },
  "notification": {
    "award": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klistra in nu"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ny utmärkelse!"])}
    },
    "gameNight": {
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To the lobby"])},
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Today we’re playing “", _interpolate(_named("gameName")), "”! Let's go!"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["It's game night!"])}
    },
    "lowMoney": {
      "text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["### Info\n\nDu har mindre än ", _interpolate(_named("threshold")), " på ditt spelarkonto. Ladda [ditt konto](#) för att kunna spela vidare."])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Info"])}
    },
    "newsletter": {
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["### Ditt nyhetsbrev\n\nSe till att få den senaste informationen om alla **nya spel** per e-mail, samtidigt som du deltar i våra **roliga tävlingar**.\n\n<button>Anmäl dig nu</button>"])}
    }
  }
});

/***/ }),

/***/ 7679:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ 9662:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(614);
var tryToString = __webpack_require__(6330);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 9483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isConstructor = __webpack_require__(4411);
var tryToString = __webpack_require__(6330);

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ 6077:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(614);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ 1223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(5112);
var create = __webpack_require__(30);
var defineProperty = (__webpack_require__(3070).f);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 1530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = (__webpack_require__(8710).charAt);

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ 5787:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isPrototypeOf = __webpack_require__(7976);

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};


/***/ }),

/***/ 9670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(111);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 8533:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $forEach = (__webpack_require__(2092).forEach);
var arrayMethodIsStrict = __webpack_require__(9341);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ 1318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(5656);
var toAbsoluteIndex = __webpack_require__(1400);
var lengthOfArrayLike = __webpack_require__(6244);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 2092:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(9974);
var uncurryThis = __webpack_require__(1702);
var IndexedObject = __webpack_require__(8361);
var toObject = __webpack_require__(7908);
var lengthOfArrayLike = __webpack_require__(6244);
var arraySpeciesCreate = __webpack_require__(5417);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 1194:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ 9341:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ 1589:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toAbsoluteIndex = __webpack_require__(1400);
var lengthOfArrayLike = __webpack_require__(6244);
var createProperty = __webpack_require__(6135);

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ 206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);

module.exports = uncurryThis([].slice);


/***/ }),

/***/ 4362:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arraySlice = __webpack_require__(1589);

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

module.exports = mergeSort;


/***/ }),

/***/ 7475:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__(3157);
var isConstructor = __webpack_require__(4411);
var isObject = __webpack_require__(111);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ 5417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arraySpeciesConstructor = __webpack_require__(7475);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 7072:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ 4326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var isCallable = __webpack_require__(614);
var classofRaw = __webpack_require__(4326);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 9920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(2597);
var ownKeys = __webpack_require__(3887);
var getOwnPropertyDescriptorModule = __webpack_require__(1236);
var definePropertyModule = __webpack_require__(3070);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 8544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 6178:
/***/ (function(module) {

"use strict";

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ 8880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 9114:
/***/ (function(module) {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 6135:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__(4948);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ 8709:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(9670);
var ordinaryToPrimitive = __webpack_require__(2140);

var $TypeError = TypeError;

// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
module.exports = function (hint) {
  anObject(this);
  if (hint === 'string' || hint === 'default') hint = 'string';
  else if (hint !== 'number') throw $TypeError('Incorrect hint');
  return ordinaryToPrimitive(this, hint);
};


/***/ }),

/***/ 7045:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var makeBuiltIn = __webpack_require__(6339);
var defineProperty = __webpack_require__(3070);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ 8052:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(614);
var definePropertyModule = __webpack_require__(3070);
var makeBuiltIn = __webpack_require__(6339);
var defineGlobalProperty = __webpack_require__(3072);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 9190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(8052);

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ 3072:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 9781:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 4154:
/***/ (function(module) {

"use strict";

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ 317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var isObject = __webpack_require__(111);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 7207:
/***/ (function(module) {

"use strict";

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 8324:
/***/ (function(module) {

"use strict";

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 8509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(317);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ 7871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IS_DENO = __webpack_require__(3823);
var IS_NODE = __webpack_require__(5268);

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';


/***/ }),

/***/ 3823:
/***/ (function(module) {

"use strict";

/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';


/***/ }),

/***/ 1528:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(8113);

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';


/***/ }),

/***/ 6833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(8113);

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ 5268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(4326);

module.exports = typeof process != 'undefined' && classof(process) == 'process';


/***/ }),

/***/ 1036:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(8113);

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ 8113:
/***/ (function(module) {

"use strict";

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ 7392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var userAgent = __webpack_require__(8113);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 748:
/***/ (function(module) {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 1060:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ 5392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var createNonEnumerableProperty = __webpack_require__(8880);
var clearErrorStack = __webpack_require__(1060);
var ERROR_STACK_INSTALLABLE = __webpack_require__(2914);

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

module.exports = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};


/***/ }),

/***/ 2914:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ 2109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
var createNonEnumerableProperty = __webpack_require__(8880);
var defineBuiltIn = __webpack_require__(8052);
var defineGlobalProperty = __webpack_require__(3072);
var copyConstructorProperties = __webpack_require__(9920);
var isForced = __webpack_require__(4705);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 7293:
/***/ (function(module) {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 7007:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(4916);
var uncurryThis = __webpack_require__(1470);
var defineBuiltIn = __webpack_require__(8052);
var regexpExec = __webpack_require__(2261);
var fails = __webpack_require__(7293);
var wellKnownSymbol = __webpack_require__(5112);
var createNonEnumerableProperty = __webpack_require__(8880);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ 2104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(4374);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ 9974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1470);
var aCallable = __webpack_require__(9662);
var NATIVE_BIND = __webpack_require__(4374);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 4374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 6916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(4374);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 6530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var hasOwn = __webpack_require__(2597);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 5668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var aCallable = __webpack_require__(9662);

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 1470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classofRaw = __webpack_require__(4326);
var uncurryThis = __webpack_require__(1702);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ 1702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(4374);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 5005:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 1246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(648);
var getMethod = __webpack_require__(8173);
var isNullOrUndefined = __webpack_require__(8554);
var Iterators = __webpack_require__(7497);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ 4121:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var aCallable = __webpack_require__(9662);
var anObject = __webpack_require__(9670);
var tryToString = __webpack_require__(6330);
var getIteratorMethod = __webpack_require__(1246);

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ 8044:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var isArray = __webpack_require__(3157);
var isCallable = __webpack_require__(614);
var classof = __webpack_require__(4326);
var toString = __webpack_require__(1340);

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) == 'Number' || classof(element) == 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};


/***/ }),

/***/ 8173:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(9662);
var isNullOrUndefined = __webpack_require__(8554);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 7854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();


/***/ }),

/***/ 2597:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var toObject = __webpack_require__(7908);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 3501:
/***/ (function(module) {

"use strict";

module.exports = {};


/***/ }),

/***/ 842:
/***/ (function(module) {

"use strict";

module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 490:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 4664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);
var createElement = __webpack_require__(317);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 8361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var classof = __webpack_require__(4326);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 9587:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);
var setPrototypeOf = __webpack_require__(7674);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ 2788:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var isCallable = __webpack_require__(614);
var store = __webpack_require__(5465);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 8340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(111);
var createNonEnumerableProperty = __webpack_require__(8880);

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ 9909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__(4811);
var global = __webpack_require__(7854);
var isObject = __webpack_require__(111);
var createNonEnumerableProperty = __webpack_require__(8880);
var hasOwn = __webpack_require__(2597);
var shared = __webpack_require__(5465);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 7659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(5112);
var Iterators = __webpack_require__(7497);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 3157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(4326);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ 614:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $documentAll = __webpack_require__(4154);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 4411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var classof = __webpack_require__(648);
var getBuiltIn = __webpack_require__(5005);
var inspectSource = __webpack_require__(2788);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 4705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 8554:
/***/ (function(module) {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(614);
var $documentAll = __webpack_require__(4154);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 1913:
/***/ (function(module) {

"use strict";

module.exports = false;


/***/ }),

/***/ 2190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);
var isCallable = __webpack_require__(614);
var isPrototypeOf = __webpack_require__(7976);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 408:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(9974);
var call = __webpack_require__(6916);
var anObject = __webpack_require__(9670);
var tryToString = __webpack_require__(6330);
var isArrayIteratorMethod = __webpack_require__(7659);
var lengthOfArrayLike = __webpack_require__(6244);
var isPrototypeOf = __webpack_require__(7976);
var getIterator = __webpack_require__(4121);
var getIteratorMethod = __webpack_require__(1246);
var iteratorClose = __webpack_require__(9212);

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ 9212:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var anObject = __webpack_require__(9670);
var getMethod = __webpack_require__(8173);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 3061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IteratorPrototype = (__webpack_require__(3383).IteratorPrototype);
var create = __webpack_require__(30);
var createPropertyDescriptor = __webpack_require__(9114);
var setToStringTag = __webpack_require__(8003);
var Iterators = __webpack_require__(7497);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ 1656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var IS_PURE = __webpack_require__(1913);
var FunctionName = __webpack_require__(6530);
var isCallable = __webpack_require__(614);
var createIteratorConstructor = __webpack_require__(3061);
var getPrototypeOf = __webpack_require__(9518);
var setPrototypeOf = __webpack_require__(7674);
var setToStringTag = __webpack_require__(8003);
var createNonEnumerableProperty = __webpack_require__(8880);
var defineBuiltIn = __webpack_require__(8052);
var wellKnownSymbol = __webpack_require__(5112);
var Iterators = __webpack_require__(7497);
var IteratorsCore = __webpack_require__(3383);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ 3383:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);
var create = __webpack_require__(30);
var getPrototypeOf = __webpack_require__(9518);
var defineBuiltIn = __webpack_require__(8052);
var wellKnownSymbol = __webpack_require__(5112);
var IS_PURE = __webpack_require__(1913);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ 7497:
/***/ (function(module) {

"use strict";

module.exports = {};


/***/ }),

/***/ 6244:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toLength = __webpack_require__(7466);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 6339:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var hasOwn = __webpack_require__(2597);
var DESCRIPTORS = __webpack_require__(9781);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(6530).CONFIGURABLE);
var inspectSource = __webpack_require__(2788);
var InternalStateModule = __webpack_require__(9909);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 4758:
/***/ (function(module) {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 5948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var bind = __webpack_require__(9974);
var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
var macrotask = (__webpack_require__(261).set);
var Queue = __webpack_require__(8572);
var IS_IOS = __webpack_require__(6833);
var IS_IOS_PEBBLE = __webpack_require__(1528);
var IS_WEBOS_WEBKIT = __webpack_require__(1036);
var IS_NODE = __webpack_require__(5268);

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var microtask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;


/***/ }),

/***/ 8523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(9662);

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 6277:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toString = __webpack_require__(1340);

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ 30:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(9670);
var definePropertiesModule = __webpack_require__(6048);
var enumBugKeys = __webpack_require__(748);
var hiddenKeys = __webpack_require__(3501);
var html = __webpack_require__(490);
var documentCreateElement = __webpack_require__(317);
var sharedKey = __webpack_require__(6200);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ 6048:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3353);
var definePropertyModule = __webpack_require__(3070);
var anObject = __webpack_require__(9670);
var toIndexedObject = __webpack_require__(5656);
var objectKeys = __webpack_require__(1956);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ 3070:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var IE8_DOM_DEFINE = __webpack_require__(4664);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3353);
var anObject = __webpack_require__(9670);
var toPropertyKey = __webpack_require__(4948);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 1236:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var call = __webpack_require__(6916);
var propertyIsEnumerableModule = __webpack_require__(5296);
var createPropertyDescriptor = __webpack_require__(9114);
var toIndexedObject = __webpack_require__(5656);
var toPropertyKey = __webpack_require__(4948);
var hasOwn = __webpack_require__(2597);
var IE8_DOM_DEFINE = __webpack_require__(4664);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 1156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__(4326);
var toIndexedObject = __webpack_require__(5656);
var $getOwnPropertyNames = (__webpack_require__(8006).f);
var arraySlice = __webpack_require__(1589);

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ 8006:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(6324);
var enumBugKeys = __webpack_require__(748);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 5181:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 9518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(2597);
var isCallable = __webpack_require__(614);
var toObject = __webpack_require__(7908);
var sharedKey = __webpack_require__(6200);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(8544);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 7976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 6324:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var hasOwn = __webpack_require__(2597);
var toIndexedObject = __webpack_require__(5656);
var indexOf = (__webpack_require__(1318).indexOf);
var hiddenKeys = __webpack_require__(3501);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 1956:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(6324);
var enumBugKeys = __webpack_require__(748);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 5296:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 7674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__(5668);
var anObject = __webpack_require__(9670);
var aPossiblePrototype = __webpack_require__(6077);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 288:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var classof = __webpack_require__(648);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ 2140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 3887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);
var uncurryThis = __webpack_require__(1702);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var anObject = __webpack_require__(9670);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);

module.exports = global;


/***/ }),

/***/ 2534:
/***/ (function(module) {

"use strict";

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ 3702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var NativePromiseConstructor = __webpack_require__(2492);
var isCallable = __webpack_require__(614);
var isForced = __webpack_require__(4705);
var inspectSource = __webpack_require__(2788);
var wellKnownSymbol = __webpack_require__(5112);
var IS_BROWSER = __webpack_require__(7871);
var IS_DENO = __webpack_require__(3823);
var IS_PURE = __webpack_require__(1913);
var V8_VERSION = __webpack_require__(7392);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);

module.exports = global.Promise;


/***/ }),

/***/ 9478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(9670);
var isObject = __webpack_require__(111);
var newPromiseCapability = __webpack_require__(8523);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ 612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NativePromiseConstructor = __webpack_require__(2492);
var checkCorrectnessOfIteration = __webpack_require__(7072);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(3702).CONSTRUCTOR);

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ 2626:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineProperty = (__webpack_require__(3070).f);

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),

/***/ 8572:
/***/ (function(module) {

"use strict";

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ 7651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var anObject = __webpack_require__(9670);
var isCallable = __webpack_require__(614);
var classof = __webpack_require__(4326);
var regexpExec = __webpack_require__(2261);

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw $TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ 2261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__(6916);
var uncurryThis = __webpack_require__(1702);
var toString = __webpack_require__(1340);
var regexpFlags = __webpack_require__(7066);
var stickyHelpers = __webpack_require__(2999);
var shared = __webpack_require__(2309);
var create = __webpack_require__(30);
var getInternalState = (__webpack_require__(9909).get);
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var UNSUPPORTED_NCG = __webpack_require__(7168);

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ 7066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(9670);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ 2999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var global = __webpack_require__(7854);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ 9441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var global = __webpack_require__(7854);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ 7168:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var global = __webpack_require__(7854);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ 4488:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isNullOrUndefined = __webpack_require__(8554);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 1150:
/***/ (function(module) {

"use strict";

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ 6340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);
var defineBuiltInAccessor = __webpack_require__(7045);
var wellKnownSymbol = __webpack_require__(5112);
var DESCRIPTORS = __webpack_require__(9781);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ 8003:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineProperty = (__webpack_require__(3070).f);
var hasOwn = __webpack_require__(2597);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ 6200:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var shared = __webpack_require__(2309);
var uid = __webpack_require__(9711);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 5465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var defineGlobalProperty = __webpack_require__(3072);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ 2309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__(1913);
var store = __webpack_require__(5465);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.32.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.32.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 6707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(9670);
var aConstructor = __webpack_require__(9483);
var isNullOrUndefined = __webpack_require__(8554);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ 8710:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var toIntegerOrInfinity = __webpack_require__(9303);
var toString = __webpack_require__(1340);
var requireObjectCoercible = __webpack_require__(4488);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ 3111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var requireObjectCoercible = __webpack_require__(4488);
var toString = __webpack_require__(1340);
var whitespaces = __webpack_require__(1361);

var replace = uncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ 6293:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(7392);
var fails = __webpack_require__(7293);
var global = __webpack_require__(7854);

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 6532:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var getBuiltIn = __webpack_require__(5005);
var wellKnownSymbol = __webpack_require__(5112);
var defineBuiltIn = __webpack_require__(8052);

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ 2015:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_SYMBOL = __webpack_require__(6293);

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ 261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var apply = __webpack_require__(2104);
var bind = __webpack_require__(9974);
var isCallable = __webpack_require__(614);
var hasOwn = __webpack_require__(2597);
var fails = __webpack_require__(7293);
var html = __webpack_require__(490);
var arraySlice = __webpack_require__(206);
var createElement = __webpack_require__(317);
var validateArgumentsLength = __webpack_require__(8053);
var IS_IOS = __webpack_require__(6833);
var IS_NODE = __webpack_require__(5268);

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ 863:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),

/***/ 1400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(9303);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 5656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(8361);
var requireObjectCoercible = __webpack_require__(4488);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 9303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var trunc = __webpack_require__(4758);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 7466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(9303);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 7908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var requireObjectCoercible = __webpack_require__(4488);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 7593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var isObject = __webpack_require__(111);
var isSymbol = __webpack_require__(2190);
var getMethod = __webpack_require__(8173);
var ordinaryToPrimitive = __webpack_require__(2140);
var wellKnownSymbol = __webpack_require__(5112);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 4948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(7593);
var isSymbol = __webpack_require__(2190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 1694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 1340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(648);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 6330:
/***/ (function(module) {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 9711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 5143:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var wellKnownSymbol = __webpack_require__(5112);
var DESCRIPTORS = __webpack_require__(9781);
var IS_PURE = __webpack_require__(1913);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (IS_PURE || !DESCRIPTORS))
    || !params.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),

/***/ 3307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(6293);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 3353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ 8053:
/***/ (function(module) {

"use strict";

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 4811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 6800:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var path = __webpack_require__(857);
var hasOwn = __webpack_require__(2597);
var wrappedWellKnownSymbolModule = __webpack_require__(6061);
var defineProperty = (__webpack_require__(3070).f);

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ 6061:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(5112);

exports.f = wellKnownSymbol;


/***/ }),

/***/ 5112:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var shared = __webpack_require__(2309);
var hasOwn = __webpack_require__(2597);
var uid = __webpack_require__(9711);
var NATIVE_SYMBOL = __webpack_require__(6293);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 1361:
/***/ (function(module) {

"use strict";

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ 9191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);
var hasOwn = __webpack_require__(2597);
var createNonEnumerableProperty = __webpack_require__(8880);
var isPrototypeOf = __webpack_require__(7976);
var setPrototypeOf = __webpack_require__(7674);
var copyConstructorProperties = __webpack_require__(9920);
var proxyAccessor = __webpack_require__(2626);
var inheritIfRequired = __webpack_require__(9587);
var normalizeStringArgument = __webpack_require__(6277);
var installErrorCause = __webpack_require__(8340);
var installErrorStack = __webpack_require__(5392);
var DESCRIPTORS = __webpack_require__(9781);
var IS_PURE = __webpack_require__(1913);

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ 2222:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var fails = __webpack_require__(7293);
var isArray = __webpack_require__(3157);
var isObject = __webpack_require__(111);
var toObject = __webpack_require__(7908);
var lengthOfArrayLike = __webpack_require__(6244);
var doesNotExceedSafeInteger = __webpack_require__(7207);
var createProperty = __webpack_require__(6135);
var arraySpeciesCreate = __webpack_require__(5417);
var arrayMethodHasSpeciesSupport = __webpack_require__(1194);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 7327:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var $filter = (__webpack_require__(2092).filter);
var arrayMethodHasSpeciesSupport = __webpack_require__(1194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 6992:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(5656);
var addToUnscopables = __webpack_require__(1223);
var Iterators = __webpack_require__(7497);
var InternalStateModule = __webpack_require__(9909);
var defineProperty = (__webpack_require__(3070).f);
var defineIterator = __webpack_require__(1656);
var createIterResultObject = __webpack_require__(6178);
var IS_PURE = __webpack_require__(1913);
var DESCRIPTORS = __webpack_require__(9781);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ 9600:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var uncurryThis = __webpack_require__(1702);
var IndexedObject = __webpack_require__(8361);
var toIndexedObject = __webpack_require__(5656);
var arrayMethodIsStrict = __webpack_require__(9341);

var nativeJoin = uncurryThis([].join);

var ES3_STRINGS = IndexedObject != Object;
var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: FORCED }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ 1249:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var $map = (__webpack_require__(2092).map);
var arrayMethodHasSpeciesSupport = __webpack_require__(1194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 6078:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(2597);
var defineBuiltIn = __webpack_require__(8052);
var dateToPrimitive = __webpack_require__(8709);
var wellKnownSymbol = __webpack_require__(5112);

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var DatePrototype = Date.prototype;

// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!hasOwn(DatePrototype, TO_PRIMITIVE)) {
  defineBuiltIn(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
}


/***/ }),

/***/ 1703:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__(2109);
var global = __webpack_require__(7854);
var apply = __webpack_require__(2104);
var wrapErrorConstructorWithCause = __webpack_require__(9191);

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ 8862:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var getBuiltIn = __webpack_require__(5005);
var apply = __webpack_require__(2104);
var call = __webpack_require__(6916);
var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var isSymbol = __webpack_require__(2190);
var arraySlice = __webpack_require__(206);
var getReplacerFunction = __webpack_require__(8044);
var NATIVE_SYMBOL = __webpack_require__(6293);

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')();
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) != '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) != '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ 9653:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var IS_PURE = __webpack_require__(1913);
var DESCRIPTORS = __webpack_require__(9781);
var global = __webpack_require__(7854);
var path = __webpack_require__(857);
var uncurryThis = __webpack_require__(1702);
var isForced = __webpack_require__(4705);
var hasOwn = __webpack_require__(2597);
var inheritIfRequired = __webpack_require__(9587);
var isPrototypeOf = __webpack_require__(7976);
var isSymbol = __webpack_require__(2190);
var toPrimitive = __webpack_require__(7593);
var fails = __webpack_require__(7293);
var getOwnPropertyNames = (__webpack_require__(8006).f);
var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
var defineProperty = (__webpack_require__(3070).f);
var thisNumberValue = __webpack_require__(863);
var trim = (__webpack_require__(3111).trim);

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var PureNumberNamespace = path[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var stringSlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = stringSlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));

var calledWithNew = function (dummy) {
  // includes check on 1..constructor(foo) case
  return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var NumberWrapper = function Number(value) {
  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
};

NumberWrapper.prototype = NumberPrototype;
if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;

$({ global: true, constructor: true, wrap: true, forced: FORCED }, {
  Number: NumberWrapper
});

// Use `internal/copy-constructor-properties` helper in `core-js@4`
var copyConstructorProperties = function (target, source) {
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(source) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);


/***/ }),

/***/ 9660:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var NATIVE_SYMBOL = __webpack_require__(6293);
var fails = __webpack_require__(7293);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var toObject = __webpack_require__(7908);

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ 1539:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var defineBuiltIn = __webpack_require__(8052);
var toString = __webpack_require__(288);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ 821:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var aCallable = __webpack_require__(9662);
var newPromiseCapabilityModule = __webpack_require__(8523);
var perform = __webpack_require__(2534);
var iterate = __webpack_require__(408);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(612);

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 4164:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var IS_PURE = __webpack_require__(1913);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(3702).CONSTRUCTOR);
var NativePromiseConstructor = __webpack_require__(2492);
var getBuiltIn = __webpack_require__(5005);
var isCallable = __webpack_require__(614);
var defineBuiltIn = __webpack_require__(8052);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),

/***/ 3401:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var IS_PURE = __webpack_require__(1913);
var IS_NODE = __webpack_require__(5268);
var global = __webpack_require__(7854);
var call = __webpack_require__(6916);
var defineBuiltIn = __webpack_require__(8052);
var setPrototypeOf = __webpack_require__(7674);
var setToStringTag = __webpack_require__(8003);
var setSpecies = __webpack_require__(6340);
var aCallable = __webpack_require__(9662);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);
var anInstance = __webpack_require__(5787);
var speciesConstructor = __webpack_require__(6707);
var task = (__webpack_require__(261).set);
var microtask = __webpack_require__(5948);
var hostReportErrors = __webpack_require__(842);
var perform = __webpack_require__(2534);
var Queue = __webpack_require__(8572);
var InternalStateModule = __webpack_require__(9909);
var NativePromiseConstructor = __webpack_require__(2492);
var PromiseConstructorDetection = __webpack_require__(3702);
var newPromiseCapabilityModule = __webpack_require__(8523);

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),

/***/ 8674:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(3401);
__webpack_require__(821);
__webpack_require__(4164);
__webpack_require__(6027);
__webpack_require__(683);
__webpack_require__(6294);


/***/ }),

/***/ 6027:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var aCallable = __webpack_require__(9662);
var newPromiseCapabilityModule = __webpack_require__(8523);
var perform = __webpack_require__(2534);
var iterate = __webpack_require__(408);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(612);

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 683:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var newPromiseCapabilityModule = __webpack_require__(8523);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(3702).CONSTRUCTOR);

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});


/***/ }),

/***/ 6294:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var getBuiltIn = __webpack_require__(5005);
var IS_PURE = __webpack_require__(1913);
var NativePromiseConstructor = __webpack_require__(2492);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(3702).CONSTRUCTOR);
var promiseResolve = __webpack_require__(9478);

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),

/***/ 4916:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var exec = __webpack_require__(2261);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ 7601:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(4916);
var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var isCallable = __webpack_require__(614);
var anObject = __webpack_require__(9670);
var toString = __webpack_require__(1340);

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (S) {
    var R = anObject(this);
    var string = toString(S);
    var exec = R.exec;
    if (!isCallable(exec)) return call(nativeTest, R, string);
    var result = call(exec, R, string);
    if (result === null) return false;
    anObject(result);
    return true;
  }
});


/***/ }),

/***/ 8783:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = (__webpack_require__(8710).charAt);
var toString = __webpack_require__(1340);
var InternalStateModule = __webpack_require__(9909);
var defineIterator = __webpack_require__(1656);
var createIterResultObject = __webpack_require__(6178);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),

/***/ 4723:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(7007);
var anObject = __webpack_require__(9670);
var isNullOrUndefined = __webpack_require__(8554);
var toLength = __webpack_require__(7466);
var toString = __webpack_require__(1340);
var requireObjectCoercible = __webpack_require__(4488);
var getMethod = __webpack_require__(8173);
var advanceStringIndex = __webpack_require__(1530);
var regExpExec = __webpack_require__(7651);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ 4765:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(7007);
var anObject = __webpack_require__(9670);
var isNullOrUndefined = __webpack_require__(8554);
var requireObjectCoercible = __webpack_require__(4488);
var sameValue = __webpack_require__(1150);
var toString = __webpack_require__(1340);
var getMethod = __webpack_require__(8173);
var regExpExec = __webpack_require__(7651);

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ 4032:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var global = __webpack_require__(7854);
var call = __webpack_require__(6916);
var uncurryThis = __webpack_require__(1702);
var IS_PURE = __webpack_require__(1913);
var DESCRIPTORS = __webpack_require__(9781);
var NATIVE_SYMBOL = __webpack_require__(6293);
var fails = __webpack_require__(7293);
var hasOwn = __webpack_require__(2597);
var isPrototypeOf = __webpack_require__(7976);
var anObject = __webpack_require__(9670);
var toIndexedObject = __webpack_require__(5656);
var toPropertyKey = __webpack_require__(4948);
var $toString = __webpack_require__(1340);
var createPropertyDescriptor = __webpack_require__(9114);
var nativeObjectCreate = __webpack_require__(30);
var objectKeys = __webpack_require__(1956);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertyNamesExternal = __webpack_require__(1156);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var getOwnPropertyDescriptorModule = __webpack_require__(1236);
var definePropertyModule = __webpack_require__(3070);
var definePropertiesModule = __webpack_require__(6048);
var propertyIsEnumerableModule = __webpack_require__(5296);
var defineBuiltIn = __webpack_require__(8052);
var defineBuiltInAccessor = __webpack_require__(7045);
var shared = __webpack_require__(2309);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);
var uid = __webpack_require__(9711);
var wellKnownSymbol = __webpack_require__(5112);
var wrappedWellKnownSymbolModule = __webpack_require__(6061);
var defineWellKnownSymbol = __webpack_require__(6800);
var defineSymbolToPrimitive = __webpack_require__(6532);
var setToStringTag = __webpack_require__(8003);
var InternalStateModule = __webpack_require__(9909);
var $forEach = (__webpack_require__(2092).forEach);

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ 1817:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(2109);
var DESCRIPTORS = __webpack_require__(9781);
var global = __webpack_require__(7854);
var uncurryThis = __webpack_require__(1702);
var hasOwn = __webpack_require__(2597);
var isCallable = __webpack_require__(614);
var isPrototypeOf = __webpack_require__(7976);
var toString = __webpack_require__(1340);
var defineBuiltInAccessor = __webpack_require__(7045);
var copyConstructorProperties = __webpack_require__(9920);

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ 763:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var getBuiltIn = __webpack_require__(5005);
var hasOwn = __webpack_require__(2597);
var toString = __webpack_require__(1340);
var shared = __webpack_require__(2309);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(2015);

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ 2165:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(6800);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ 2526:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(4032);
__webpack_require__(763);
__webpack_require__(6620);
__webpack_require__(8862);
__webpack_require__(9660);


/***/ }),

/***/ 6620:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var hasOwn = __webpack_require__(2597);
var isSymbol = __webpack_require__(2190);
var tryToString = __webpack_require__(6330);
var shared = __webpack_require__(2309);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(2015);

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ 6649:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(6800);
var defineSymbolToPrimitive = __webpack_require__(6532);

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();


/***/ }),

/***/ 4747:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var DOMIterables = __webpack_require__(8324);
var DOMTokenListPrototype = __webpack_require__(8509);
var forEach = __webpack_require__(8533);
var createNonEnumerableProperty = __webpack_require__(8880);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ 3948:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var DOMIterables = __webpack_require__(8324);
var DOMTokenListPrototype = __webpack_require__(8509);
var ArrayIteratorMethods = __webpack_require__(6992);
var createNonEnumerableProperty = __webpack_require__(8880);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ 5556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(6992);
var $ = __webpack_require__(2109);
var global = __webpack_require__(7854);
var call = __webpack_require__(6916);
var uncurryThis = __webpack_require__(1702);
var DESCRIPTORS = __webpack_require__(9781);
var USE_NATIVE_URL = __webpack_require__(5143);
var defineBuiltIn = __webpack_require__(8052);
var defineBuiltInAccessor = __webpack_require__(7045);
var defineBuiltIns = __webpack_require__(9190);
var setToStringTag = __webpack_require__(8003);
var createIteratorConstructor = __webpack_require__(3061);
var InternalStateModule = __webpack_require__(9909);
var anInstance = __webpack_require__(5787);
var isCallable = __webpack_require__(614);
var hasOwn = __webpack_require__(2597);
var bind = __webpack_require__(9974);
var classof = __webpack_require__(648);
var anObject = __webpack_require__(9670);
var isObject = __webpack_require__(111);
var $toString = __webpack_require__(1340);
var create = __webpack_require__(30);
var createPropertyDescriptor = __webpack_require__(9114);
var getIterator = __webpack_require__(4121);
var getIteratorMethod = __webpack_require__(1246);
var validateArgumentsLength = __webpack_require__(8053);
var wellKnownSymbol = __webpack_require__(5112);
var arraySort = __webpack_require__(4362);

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!DESCRIPTORS) return global[name];
  var descriptor = getOwnPropertyDescriptor(global, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp = global.RegExp;
var TypeError = global.TypeError;
var decodeURIComponent = global.decodeURIComponent;
var encodeURIComponent = global.encodeURIComponent;
var charAt = uncurryThis(''.charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw TypeError('Expected sequence with length 2');
        push(this.entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push(this.entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(this.entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS) this.size = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 2);
    push(state.entries, { key: $toString(name), value: $toString(value) });
    if (!DESCRIPTORS) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice(entries, index, 1);
        if (value !== undefined) break;
      } else index++;
    }
    if (!DESCRIPTORS) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    if (!DESCRIPTORS) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis(HeadersPrototype.has);
  var headersSet = uncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ 6229:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(8052);
var uncurryThis = __webpack_require__(1702);
var toString = __webpack_require__(1340);
var validateArgumentsLength = __webpack_require__(8053);

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var append = uncurryThis(URLSearchParamsPrototype.append);
var $delete = uncurryThis(URLSearchParamsPrototype['delete']);
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
var push = uncurryThis([].push);
var params = new $URLSearchParams('a=1&a=2&b=3');

params['delete']('a', 1);
// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
params['delete']('b', undefined);

if (params + '' !== 'a=2') {
  defineBuiltIn(URLSearchParamsPrototype, 'delete', function (name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $delete(this, name);
    var entries = [];
    forEach(this, function (v, k) { // also validates `this`
      push(entries, { key: k, value: v });
    });
    validateArgumentsLength(length, 1);
    var key = toString(name);
    var value = toString($value);
    var index = 0;
    var dindex = 0;
    var found = false;
    var entriesLength = entries.length;
    var entry;
    while (index < entriesLength) {
      entry = entries[index++];
      if (found || entry.key === key) {
        found = true;
        $delete(this, entry.key);
      } else dindex++;
    }
    while (dindex < entriesLength) {
      entry = entries[dindex++];
      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
    }
  }, { enumerable: true, unsafe: true });
}


/***/ }),

/***/ 7330:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(8052);
var uncurryThis = __webpack_require__(1702);
var toString = __webpack_require__(1340);
var validateArgumentsLength = __webpack_require__(8053);

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var getAll = uncurryThis(URLSearchParamsPrototype.getAll);
var $has = uncurryThis(URLSearchParamsPrototype.has);
var params = new $URLSearchParams('a=1');

// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
if (params.has('a', 2) || !params.has('a', undefined)) {
  defineBuiltIn(URLSearchParamsPrototype, 'has', function has(name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $has(this, name);
    var values = getAll(this, name); // also validates `this`
    validateArgumentsLength(length, 1);
    var value = toString($value);
    var index = 0;
    while (index < values.length) {
      if (values[index++] === value) return true;
    } return false;
  }, { enumerable: true, unsafe: true });
}


/***/ }),

/***/ 1637:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(5556);


/***/ }),

/***/ 2062:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var uncurryThis = __webpack_require__(1702);
var defineBuiltInAccessor = __webpack_require__(7045);

var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
    get: function size() {
      var count = 0;
      forEach(this, function () { count++; });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}


/***/ }),

/***/ 8973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./i18n.json": 8512,
	"./i18n_da.json": 4506,
	"./i18n_de.json": 8806,
	"./i18n_en-GB.json": 2088,
	"./i18n_en.json": 5723,
	"./i18n_es.json": 7875,
	"./i18n_fr.json": 8026,
	"./i18n_nl.json": 5185,
	"./i18n_sv.json": 2469
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8973;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  NotificationOptions: function() { return /* reexport */ Notifications_namespaceObject.Options; },
  Notifications: function() { return /* reexport */ Notifications; }
});

// NAMESPACE OBJECT: ./src/lib/Notifications.ts
var Notifications_namespaceObject = {};
__webpack_require__.r(Notifications_namespaceObject);
__webpack_require__.d(Notifications_namespaceObject, {
  Z: function() { return Notifications; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__(7679)
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(1703);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(2526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(1817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(1539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(2165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(6992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(8783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(3948);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(6649);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(6078);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js








function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(8674);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(4916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(7601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__(4765);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__(1637);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(6229);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(7330);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(2062);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(7327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(1249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(2222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(4747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(4723);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(9600);
;// CONCATENATED MODULE: ./node_modules/@gd/storage/dist/SessionStore.js
var SessionStore = /** @class */ (function () {
    function SessionStore(_a) {
        var customId = _a.customId;
        if (customId) {
            this.custom = JSON.parse(sessionStorage.getItem(customId) || '{}');
        }
    }
    SessionStore.prototype.storeCustom = function (id, data) {
        this.custom = Object.assign({}, this.custom, data);
        sessionStorage.setItem(id, JSON.stringify(this.custom));
    };
    return SessionStore;
}());
/* harmony default export */ var dist_SessionStore = (SessionStore);
//# sourceMappingURL=SessionStore.js.map
;// CONCATENATED MODULE: ./node_modules/@gd/storage/dist/STORE.js
var STORE_NAME;
(function (STORE_NAME) {
    // essential
    STORE_NAME["ACCESS_TOKEN"] = "access_token";
    STORE_NAME["ACCOUNTBOX"] = "accountbox";
    STORE_NAME["CID"] = "cid";
    STORE_NAME["COOKIE_CONSENT"] = "cookieConsent";
    STORE_NAME["GD"] = "gd";
    STORE_NAME["HOME_ESSENTIAL"] = "home-essential";
    STORE_NAME["JSESSIONID"] = "JSESSIONID";
    STORE_NAME["PHONITAIRE"] = "phonitaire";
    STORE_NAME["SHOP_WEB"] = "shop-web";
    STORE_NAME["SHOP_ESSENTIAL"] = "shop-essential";
    STORE_NAME["SESSION_HOST"] = "SESSION_HOST";
    STORE_NAME["USER"] = "user";
    // functional
    STORE_NAME["LOBBY"] = "lobby";
    STORE_NAME["SHOP"] = "shop";
})(STORE_NAME || (STORE_NAME = {}));
//# sourceMappingURL=STORE.js.map
;// CONCATENATED MODULE: ./node_modules/@gd/storage/dist/GD.js

/*
 *  Copyright (c) 2003-2019 GameDuell GmbH, All Rights Reserved
 *  This document is strictly confidential and sole property of GameDuell GmbH, Berlin, Germany
 */
/**
 * localStorage scope GD
 */
var GD = /** @class */ (function () {
    function GD() {
        var gd = JSON.parse(localStorage.getItem('gd') || '{}');
        this.viewLang = gd.viewLang;
        this.viewCountry = gd.viewCountry;
        this.webCtxPath = gd.webCtxPath || '/web';
        this.mediaUrl = gd.mediaUrl || '//assets.gameduell.de/res/moduleMedia/';
        this.avatarUrl = gd.avatarUrl || '//assets.gameduell.de/avatar/';
        this.partner = {
            name: (gd.partner && gd.partner.name) || '',
            url: (gd.partner && gd.partner.url) || '',
        };
        this.supportedLocales = gd.supportedLocales || [
            'en-US',
            'en-GB',
            // 'es-ES',
            // 'fr-FR',
            'nl-NL',
            'se-SV',
            'da-DK',
            'de-DE',
            'de-AT',
        ];
        this.supportedTechs = gd.supportedTechs || ['html5_dom'];
        this.blackRibbon = gd.blackRibbon || false;
        this.theme = gd.theme || '';
        this.cookieConsent = {
            consented: (gd.cookieConsent && gd.cookieConsent.consented) || false,
            auto: (gd.cookieConsent && gd.cookieConsent.auto) || false,
            functional: (gd.cookieConsent && gd.cookieConsent.functional) || false,
            marketing: (gd.cookieConsent && gd.cookieConsent.marketing) || false,
            names: (gd.cookieConsent && gd.cookieConsent.names) || [
                STORE_NAME.ACCESS_TOKEN,
                STORE_NAME.ACCOUNTBOX,
                STORE_NAME.CID,
                STORE_NAME.COOKIE_CONSENT,
                STORE_NAME.GD,
                STORE_NAME.HOME_ESSENTIAL,
                STORE_NAME.JSESSIONID,
                STORE_NAME.PHONITAIRE,
                STORE_NAME.SHOP_WEB,
                STORE_NAME.SHOP_ESSENTIAL,
                STORE_NAME.SESSION_HOST,
                STORE_NAME.USER,
            ],
        };
        this.decisions = gd.decisions || [];
        this.mobileDevice = gd.mobileDevice || false;
        this.betaMobil = gd.betaMobil || false;
        this.deviceType = gd.deviceType || 'desktop';
        this.trackingConfig = gd.trackingConfig || [];
    }
    return GD;
}());

//# sourceMappingURL=GD.js.map
;// CONCATENATED MODULE: ./node_modules/@gd/storage/dist/User.js
/*
 *  Copyright (c) 2003-2019 GameDuell GmbH, All Rights Reserved
 *  This document is strictly confidential and sole property of GameDuell GmbH, Berlin, Germany
 */
/**
 * localStorage scope GD
 */
var User = /** @class */ (function () {
    function User() {
        var user = JSON.parse(localStorage.getItem('user') || '{}');
        this.id = user.id;
        this.currency = user.currency;
        this.name = user.name;
        this.actorType = user.actorType;
        this.locale = user.locale;
        this.loyalty = user.loyalty;
        this.bonusVisualization = user.bonusVisualization;
        this.payout = user.payout;
        this.forcePayout = user.forcePayout || false;
        this.boku = user.boku;
        this.avatarUrl = user.avatarUrl;
    }
    return User;
}());

//# sourceMappingURL=User.js.map
;// CONCATENATED MODULE: ./node_modules/@gd/storage/dist/LocalStore.js


var LocaleStore = /** @class */ (function () {
    function LocaleStore(_a) {
        var customId = _a.customId;
        this.gd = new GD();
        this.user = new User();
        if (customId) {
            this.custom = JSON.parse(localStorage.getItem(customId) || '{}');
        }
    }
    LocaleStore.prototype.storeGD = function (gd) {
        this.gd = Object.assign({}, this.gd, gd);
        localStorage.setItem('gd', JSON.stringify(this.gd));
        console.warn('storeCustom is deprecated - use storage.write', 'gd');
    };
    LocaleStore.prototype.storeUser = function (user) {
        this.user = Object.assign({}, this.user, user);
        localStorage.setItem('user', JSON.stringify(this.user));
        console.warn('storeCustom is deprecated - use storage.write', 'user');
    };
    LocaleStore.prototype.storeCustom = function (id, data) {
        this.custom = Object.assign({}, this.custom, data);
        localStorage.setItem(id, JSON.stringify(this.custom));
        console.warn('storeCustom is deprecated - use storage.write', id);
    };
    return LocaleStore;
}());
/* harmony default export */ var LocalStore = (LocaleStore);
//# sourceMappingURL=LocalStore.js.map
;// CONCATENATED MODULE: ./node_modules/@gd/storage/dist/Storage.js



/**
 * Supports read/write localStorage - write works only for cookie consent allowed names (see gd.cookieConsent.names)
 * TODO: refactor too much read and write when creating a instance. The problem on lazy loading/saving the data is
 * too support multiple instances of this Storage object.
 */
var Storage = /** @class */ (function () {
    /**
     * Initialize defaults
     */
    function Storage() {
        this.defaults = {};
        this.defaults.gd = new GD();
        this.defaults.user = new User();
    }
    /**
     * Returns a object from localStorage (already JSON parsed).
     *
     * Will handle default values for GD and User.
     * @param store
     */
    Storage.prototype.read = function (store) {
        var _this = this;
        var data = localStorage.getItem(store);
        var dataObj = JSON.parse(data || '{}');
        if (this.defaults[store]) {
            Object.keys(this.defaults[store]).forEach(function (key) {
                if (dataObj[key] === undefined) {
                    dataObj[key] = _this.defaults[store][key];
                }
            });
        }
        return dataObj;
    };
    /**
     * writes data to locale storage. Only cookies which are accepted in cookieConsent will be saved
     * @param store
     * @param data
     */
    Storage.prototype.write = function (store, data) {
        // would be great to cache this but if we create multiple instance from Storage it will not work ;)
        var gd = this.read(STORE_NAME.GD);
        if (gd.cookieConsent.names.indexOf(store) === -1) {
            // skip write if cookie names are not part of the cookie consent
            console.warn('block save settings by user - you need to activate cookie saving ( see cookie consent agreement )');
            return;
        }
        var custom = Object.assign({}, this.read(store) || {}, data);
        localStorage.setItem(store, JSON.stringify(custom));
    };
    return Storage;
}());
/* harmony default export */ var dist_Storage = (Storage);
//# sourceMappingURL=Storage.js.map
;// CONCATENATED MODULE: ./node_modules/@gd/storage/dist/vuexSessionStore.js

// initial state
var state = {
    storageSessionCustom: {},
    customSessionId: ''
};
// getters
var getters = {
    storageSessionCustom: function (state) { return state.storageSessionCustom; }
};
// actions
var actions = {
    storageSessionInit: function (_a, _b) {
        var commit = _a.commit;
        var customId = _b.customId;
        var sessionStorage = new dist_SessionStore({ customId: customId });
        commit('storageSessionCustom', { id: customId, data: sessionStorage.custom });
        commit('storageSessionSetCustomId', customId);
    }
};
// mutations
var mutations = {
    storageSessionSetCustomId: function (state, id) {
        state.customSessionId = id;
    },
    /**
     * id is optional - it's using the id from the storageInit: customId as default
     */
    storageSessionCustom: function (state, _a) {
        var id = _a.id, data = _a.data;
        // TODO: apply deep merge of objects
        state.storageSessionCustom = Object.assign({}, state.storageSessionCustom, data);
        sessionStorage.setItem(id || state.customSessionId, JSON.stringify(state.storageSessionCustom));
    }
};
/* harmony default export */ var vuexSessionStore = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});
//# sourceMappingURL=vuexSessionStore.js.map
;// CONCATENATED MODULE: ./node_modules/@gd/storage/dist/vuexLocalStore.js

// initial state
var vuexLocalStore_state = {
    storageGD: new LocalStore({}).gd,
    storageUser: new LocalStore({}).user,
    storageCustom: {},
    customId: ''
};
// getters
var vuexLocalStore_getters = {
    storageGD: function (state) { return state.storageGD; },
    storageUser: function (state) { return state.storageUser; },
    storageCustom: function (state) { return state.storageCustom; },
    webPath: function (state) {
        return state.storageGD.webCtxPath;
    }
};
// actions
var vuexLocalStore_actions = {
    storageInit: function (_a, _b) {
        var commit = _a.commit;
        var customId = _b.customId;
        var localStorage = new LocalStore({ customId: customId });
        commit('storageCustom', { id: customId, data: localStorage.custom });
        commit('storageSetCustomId', customId);
    }
};
// mutations
var vuexLocalStore_mutations = {
    storageSetCustomId: function (state, id) {
        state.customId = id;
    },
    storageGD: function (state, gdInt) {
        state.storageGD = Object.assign({}, state.storageGD, gdInt);
        localStorage.setItem('gd', JSON.stringify(state.storageGD));
    },
    storageUser: function (state, userInt) {
        state.storageUser = Object.assign({}, state.storageUser, userInt);
        localStorage.setItem('user', JSON.stringify(state.storageUser));
    },
    /**
     * id is optional - it's using the id from the storageInit: customId as default
     */
    storageCustom: function (state, _a) {
        var id = _a.id, data = _a.data;
        // TODO: apply deep merge of objects
        state.storageCustom = Object.assign({}, state.storageCustom, data);
        localStorage.setItem(id || state.customId, JSON.stringify(state.storageCustom));
    }
};
/* harmony default export */ var vuexLocalStore = ({
    state: vuexLocalStore_state,
    getters: vuexLocalStore_getters,
    actions: vuexLocalStore_actions,
    mutations: vuexLocalStore_mutations
});
//# sourceMappingURL=vuexLocalStore.js.map
;// CONCATENATED MODULE: ./node_modules/@gd/storage/dist/index.js








/**
 * Make all of them public
 */







//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./src/lib/i18n.ts







// import i18n from './locales/i18n.json'

/**
 * maps viewLang and viewCountry to $i18n.locale
 */
var mapLang = {
  'en-US': 'en',
  'en-GB': 'en-GB',
  'nl-NL': 'nl',
  'sv-SE': 'sv',
  'da-DK': 'dk',
  'de-DE': 'de',
  'de-AT': 'de',
  'es-ES': 'es',
  'fr-FR': 'fr'
};
var storageGd = new dist_Storage().read(STORE_NAME.GD);
function loadLocaleMessages() {
  // not nice but webpack requires to pass the folder as string literal - variables are not allowed
  // the alternative to this is to move out the required.context call to the parent component and pass
  // the locales as parameter.
  // path out: ./node_modules/@gd/i18n/dist/
  // path in: ./src/locales/
  var locales = __webpack_require__(8973);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1].split('_')[1];
      if (locale) {
        // TODO - find out when it's default and when it's not
        messages[locale] = locales(key).default || locales(key);
        if (locale === 'de') {
          messages['de-AT'] = locales(key);
        }
      }
    }
  });
  var i18n = locales('./i18n.json');
  if (i18n) {
    ;
    messages['none'] = i18n.default;
  }
  return messages;
}
var lang = storageGd.viewLang + '-' + storageGd.viewCountry;
var messages = loadLocaleMessages();
window.messages = messages;
function i18n(key, values) {
  var bundle = messages[mapLang[lang]];
  if (!bundle) bundle = messages[storageGd.viewLang || 'en'];
  var keys = key.split('.');
  var obj = bundle;
  keys.forEach(function (key) {
    var o = obj[key];
    if (o) {
      obj = o;
    }
  });
  // "text": (()=>{const fn=(ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["### Konto aufladen\n\nIhr Kontostand beträgt weniger als ", _interpolate(_named("threshold")), ". Laden Sie jetzt schnell [Ihr Konto](#) auf und spielen Sie weiter!"])};fn.source="### Konto aufladen\n\nIhr Kontostand beträgt weniger als {threshold}. Laden Sie jetzt schnell [Ihr Konto](#) auf und spielen Sie weiter!";return fn;})(),
  return obj({
    normalize: function normalize(s) {
      return s.join('');
    },
    interpolate: function interpolate(name) {
      return values[name];
    },
    named: function named(s) {
      return s;
    }
  });
}
/**
 * web export for createApp(...).use(i18n)
 */
/* harmony default export */ var lib_i18n = (i18n);
;// CONCATENATED MODULE: ./src/lib/Award.ts









var Award = /*#__PURE__*/function () {
  function Award(config, callback) {
    _classCallCheck(this, Award);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "sendCloseCall", true);
    _defineProperty(this, "callback", void 0);
    _defineProperty(this, "t", void 0);
    this.config = config;
    this.callback = callback;
    this.t = lib_i18n;
  }
  _createClass(Award, [{
    key: "toastOptions",
    get: function get() {
      var _this = this;
      return {
        sticky: true,
        icon: 'icf-winnings',
        className: 'notifications-toast-message',
        color: 'purple',
        onClose: function onClose() {
          // make sure delete is not called twice
          if (_this.sendCloseCall) {
            fetch("/gd/rest/me/notifications/".concat(_this.config.type, "?awardId=").concat(_this.config.id), {
              credentials: 'same-origin',
              method: 'DELETE'
            });
            _this.callback({
              type: _this.config.type,
              action: 'close',
              payload: ''
            });
          }
        },
        onContent: function onContent(e) {
          // detect that the button is clicked
          if (e.target && e.target.tagName === 'BUTTON') {
            _this.sendCloseCall = false;
            _this.callback({
              type: _this.config.type,
              payload: "/gd/awards/trophies.xhtml?gametype=".concat(_this.config.gametype),
              action: 'click'
            }).then(function (stopPropagation) {
              if (!stopPropagation) {
                location.href = "/gd/awards/trophies.xhtml?gametype=".concat(_this.config.gametype);
              }
            }).catch(function (err) {
              return void 0;
            });
          } else {
            // stop propagation will prevent toast from self closing
            e.stopPropagation();
          }
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      return "<div class=\"notifications-award\">\n      <h3>".concat(this.t('notification.award.title'), "</h3> \n      <strong>").concat(this.config.title, "</strong>\n      <div class=\"notifications-row\">\n        <img src=\"").concat(this.config.image, "\"></img>\n        <p>").concat(this.config.description, "</p>\n      </div>\n      <button class=\"colorButton\">").concat(this.t('notification.award.button'), "</button></div>");
    }
  }]);
  return Award;
}();
;// CONCATENATED MODULE: ./src/lib/Newsletter.ts






var Newsletter = /*#__PURE__*/function () {
  function Newsletter(config, callback) {
    _classCallCheck(this, Newsletter);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "callback", void 0);
    _defineProperty(this, "deleteCalled", false);
    _defineProperty(this, "t", void 0);
    this.config = config;
    this.callback = callback;
    this.t = lib_i18n;
  }
  _createClass(Newsletter, [{
    key: "toastOptions",
    get: function get() {
      var _this = this;
      return {
        sticky: true,
        icon: 'icf-message',
        className: 'notifications-toast-message',
        color: 'lightBlue',
        onClose: function onClose() {
          // make sure delete is nto called twice
          if (!_this.deleteCalled) {
            fetch('/gd/rest/me/notifications/' + _this.config.type, {
              credentials: 'same-origin',
              method: 'DELETE'
            });
            _this.callback({
              type: _this.config.type,
              action: 'close'
            });
          }
        },
        onContent: function onContent(e) {
          // detect that the button is clicked
          if (e.target && e.target.tagName === 'BUTTON') {
            _this.deleteCalled = true;
            fetch('/gd/rest/me/notifications/' + _this.config.type, {
              credentials: 'same-origin',
              method: 'DELETE'
            }).then(function () {
              return _this.callback({
                type: _this.config.type,
                action: 'click'
              });
            }).then(function (stopPropagation) {
              if (!stopPropagation) {
                location.href = '/gd/emailManagement/emailManagement.xhtml';
              }
            }).catch(function (err) {
              return void 0;
            });
          } else {
            // stop propagation will prevent toast from self closing
            e.stopPropagation();
          }
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      return "".concat(this.t('notification.newsletter.text'));
    }
  }]);
  return Newsletter;
}();
;// CONCATENATED MODULE: ./node_modules/@gd/currency-converter/dist/lib/GDC_CODES.js
/**
 *
 * @type {{GGBP: {symbol: string, digits: number, locale: string}, GBP: {symbol: string, digits: number, locale: string}, GUSD: {symbol: string, digits: number, locale: string}, USD: {symbol: string, digits: number, locale: string}, GSEK: {symbol: string, digits: number, locale: string}, SEK: {symbol: string, digits: number, locale: string}, GDKK: {symbol: string, digits: number, locale: string}, DKK: {symbol: string, digits: number, locale: string}, EUR: {symbol: string, digits: number, locale: string}, DIA: {symbol: string, symbolShort: string, digits: number, locale: string}, CAD: {symbol: string, digits: number, locale: string}}}
 */
var GDC_CODES = {
    GGBP: {
        symbol: 'G\u00a3',
        digits: 0,
        factor: 100,
        locale: 'en-GB',
    },
    GBP: {
        symbol: '\u00a3',
        digits: 2,
        factor: 1,
        locale: 'en-GB',
    },
    GUSD: {
        symbol: 'G$',
        digits: 0,
        factor: 100,
        locale: 'en-US',
    },
    USD: {
        symbol: '$',
        digits: 2,
        factor: 1,
        locale: 'en-US',
    },
    GSEK: {
        symbol: 'Gkr',
        digits: 0,
        factor: 100,
        locale: 'sv-SE',
    },
    SEK: {
        symbol: 'kr',
        digits: 2,
        factor: 1,
        locale: 'sv-SE',
    },
    GDKK: {
        symbol: 'Gkr',
        digits: 0,
        factor: 100,
        locale: 'da-DK',
    },
    DKK: {
        symbol: 'kr.',
        digits: 2,
        factor: 1,
        locale: 'da-DK',
    },
    EUR: {
        symbol: '\u20ac',
        digits: 2,
        factor: 1,
        locale: 'de',
    },
    DIA: {
        symbol: 'Diamants',
        // symbolShort: 'D',
        digits: 0,
        factor: 100,
        locale: 'fr',
    },
    CAD: {
        symbol: '$',
        digits: 2,
        factor: 1,
        locale: 'en-CA',
    },
    CRED: {
        symbol: 'Credits',
        digits: 0,
        factor: 100,
        locale: 'en-US',
    },
};
var GDC_CODES_FALLBACK = {
    GGBP: {
        exp: GDC_CODES.GGBP.symbol + "{num}",
    },
    GBP: {
        exp: GDC_CODES.GBP.symbol + "{num}",
    },
    GUSD: { exp: GDC_CODES.GUSD.symbol + "{num}" },
    USD: { exp: GDC_CODES.USD.symbol + "{num}" },
    GSEK: { exp: "{num}\u00A0" + GDC_CODES.GSEK.symbol },
    SEK: { exp: "{num}\u00A0" + GDC_CODES.SEK.symbol },
    GDKK: { exp: "{num}\u00A0" + GDC_CODES.GDKK.symbol },
    DKK: { exp: "{num}\u00A0" + GDC_CODES.DKK.symbol },
    EUR: { exp: "{num}\u00A0" + GDC_CODES.EUR.symbol },
    DIA: { exp: "{num}\u00A0" + GDC_CODES.DIA.symbol },
    CAD: { exp: GDC_CODES.CAD.symbol + "{num}" },
    CRED: { exp: "{num}\u00A0" + GDC_CODES.CRED.symbol },
};
/* harmony default export */ var lib_GDC_CODES = ((/* unused pure expression or super */ null && (GDC_CODES)));

//# sourceMappingURL=GDC_CODES.js.map
;// CONCATENATED MODULE: ./node_modules/@gd/currency-converter/dist/lib/converter.js

var cutomGDC_CODES = ['GUSD', 'DIA', 'GDKK', 'GSEK', 'GGBP', 'CRED'];
/**
 * cut to 2 maximum digits
 * @param value
 */
function digitsCut(value) {
    var lengthToCut = value.length - parseFloat(value).toFixed(2).length;
    if (lengthToCut > 0) {
        return value.slice(0, lengthToCut * -1);
    }
    return value;
}
function convertValue(value, gdc) {
    var v = parseFloat(digitsCut('' + value));
    return v * GDC_CODES[gdc].factor;
}
function checkIfBrowserSupportsIntl(locales) {
    var supportsLocale = !!(typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function'), supportedLocaleList;
    if (supportsLocale) {
        supportsLocale = false;
        supportedLocaleList = Intl.NumberFormat.supportedLocalesOf(locales);
        for (var i = 0; i < locales.length; i++) {
            if (supportedLocaleList.indexOf(locales[i]) !== -1) {
                supportsLocale = true;
            }
        }
    }
    return supportsLocale;
}
function getDelemitter(locale) {
    return (1.1).toLocaleString(locale).split('1')[1];
}
function handlePrimitivFormatting(value, gdc) {
    var delemitter = getDelemitter(GDC_CODES[gdc].locale);
    var n = GDC_CODES[gdc].factor === 100 ? parseInt('' + value) : parseFloat('' + value);
    var v = n.toLocaleString(GDC_CODES[gdc].locale);
    if (GDC_CODES[gdc].factor === 1) {
        if (v.indexOf(delemitter) === -1) {
            // no delemitter
            v += delemitter + "00";
        }
        else {
            // make sure we have only 2 digits
            var split = v.split(delemitter);
            if (split[1].length < 2) {
                v += '0';
            }
            else if (split[1].length > 2) {
                v = split[0] + delemitter + split[1].slice(0, 2);
            }
        }
    }
    return GDC_CODES_FALLBACK[gdc].exp.replace('{num}', '' + v);
}
function convert(value, obj) {
    if (!obj)
        throw new Error('Missing second argument');
    if (!obj.gdc)
        throw new Error('Missing gdc property in second argument');
    if (obj.locale === undefined)
        obj.locale = GDC_CODES[obj.gdc].locale;
    if (checkIfBrowserSupportsIntl([obj.locale])) {
        if (cutomGDC_CODES.indexOf(obj.gdc) !== -1) {
            // DIA and CRED are rendered as "currencyDisplay: 'name'" - this is in all languages
            var intl = new Intl.NumberFormat(obj.locale, {
                style: 'currency',
                currency: 'EUR',
                currencyDisplay: obj.gdc === 'DIA' || obj.gdc === 'CRED' ? 'name' : 'symbol',
                minimumFractionDigits: GDC_CODES[obj.gdc].digits,
                maximumFractionDigits: GDC_CODES[obj.gdc].digits,
            });
            return (intl
                .format(convertValue(value, obj.gdc))
                .replace(/€|EUR|euros|Euro|euro/, GDC_CODES[obj.gdc].symbol)
                .replace(' ', '\u00A0')
                // cut digits - thanks to edge which has a bug which ignores
                // the minimumFractionDigits https://github.com/microsoft/ChakraCore/issues/6029
                //...so lets cut everything after the delemitter which is a number
                .replace(GDC_CODES[obj.gdc].digits === 0 ? new RegExp("\\" + getDelemitter(obj.locale) + "[0-9]*") : '', ''));
        }
        else {
            var intl = new Intl.NumberFormat(obj.locale, { style: 'currency', currency: obj.gdc });
            return intl.format(convertValue(value, obj.gdc));
        }
    }
    else {
        // fallback handler
        // TODO:jslog if we still need support this
        return handlePrimitivFormatting(convertValue(value, obj.gdc), obj.gdc);
    }
}
//# sourceMappingURL=converter.js.map
;// CONCATENATED MODULE: ./node_modules/@gd/currency-converter/dist/index.js

/* harmony default export */ var dist = ((/* unused pure expression or super */ null && (gdcConverter)));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./src/lib/getViewLocale.ts

/**
 * Returns the view lang or locale (GB) from storage
 */
function getViewLocale() {
  var storageGd = new dist_Storage().read(STORE_NAME.GD);
  var viewLang = storageGd.viewLang || 'en';
  // read default  view locale from storage
  if (storageGd.viewCountry === 'GB') {
    viewLang += '-GB';
  }
  return viewLang;
}
;// CONCATENATED MODULE: ./src/lib/currencyFormat.ts



var currencyToFactorMap = {
  GGBP: 100,
  GBP: 1,
  GUSD: 100,
  USD: 1,
  GSEK: 100,
  SEK: 1,
  GDKK: 100,
  DKK: 1,
  EUR: 1,
  DIA: 100,
  CAD: 1
};
var viewLocale;
var storage = new LocalStore({});
var languageDefaults = {
  US: 'en-US',
  DE: 'de-DE',
  AT: 'de-AT',
  NL: 'nl-NL',
  SE: 'sv-SE',
  DK: 'da-DK',
  GB: 'en-GB',
  CA: 'en-CA'
};
/* harmony default export */ var currencyFormat = ({
  format: function format(number) {
    var gdc = storage.user.currency;
    if (!gdc) {
      throw "Can't convert currency - GDC IS MISSING";
    }
    var locale = getViewLocale();
    return convert(number, {
      gdc: gdc,
      locale: locale || viewLocale
    });
  }
});
;// CONCATENATED MODULE: ./src/lib/LowMoney.ts







var LowMoney = /*#__PURE__*/function () {
  function LowMoney(config, callback) {
    _classCallCheck(this, LowMoney);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "callback", void 0);
    _defineProperty(this, "t", void 0);
    _defineProperty(this, "deleteCalled", false);
    this.config = config;
    this.callback = callback;
    this.t = lib_i18n;
  }
  _createClass(LowMoney, [{
    key: "toastOptions",
    get: function get() {
      var _this = this;
      return {
        sticky: true,
        icon: 'icf-alert',
        color: 'yellow',
        className: 'notifications-toast-message',
        onClose: function onClose() {
          // make sure delete is nto called twice
          if (!_this.deleteCalled) {
            fetch('/gd/rest/me/notifications/' + _this.config.type, {
              credentials: 'same-origin',
              method: 'DELETE'
            });
            _this.callback({
              type: _this.config.type,
              action: 'close'
            });
          }
        },
        onContent: function onContent(e) {
          // detect that the button is clicked
          if (e.target && e.target.tagName === 'A') {
            _this.deleteCalled = true;
            fetch('/gd/rest/me/notifications/' + _this.config.type, {
              credentials: 'same-origin',
              method: 'DELETE'
            }).then(function () {
              return _this.callback({
                type: _this.config.type,
                action: 'click'
              });
            }).then(function (stopPropagation) {
              if (!stopPropagation) {
                ;
                window.GD.shop.navigateTo();
              }
            }).catch(function (err) {
              return void 0;
            });
          } else {
            // stop propagation will prevent toast from self closing
            e.stopPropagation();
          }
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      return "".concat(this.t('notification.lowMoney.text', {
        threshold: currencyFormat.format(this.config.threshold)
      }));
    }
  }]);
  return LowMoney;
}();
;// CONCATENATED MODULE: ./src/lib/GameNight.ts







var GameNight = /*#__PURE__*/function () {
  function GameNight(config, callback) {
    _classCallCheck(this, GameNight);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "callback", void 0);
    _defineProperty(this, "deleteCalled", false);
    _defineProperty(this, "t", void 0);
    this.config = config;
    this.callback = callback;
    this.t = lib_i18n;
  }
  _createClass(GameNight, [{
    key: "toastOptions",
    get: function get() {
      var _this = this;
      return {
        sticky: true,
        icon: 'icf-community',
        className: 'notifications-toast-message',
        color: 'midGreen',
        onClose: function onClose() {
          // make sure delete is not called twice
          if (!_this.deleteCalled) {
            fetch('/gd/rest/me/notifications/' + _this.config.type, {
              credentials: 'same-origin',
              method: 'DELETE'
            });
            _this.callback({
              type: _this.config.type,
              action: 'close'
            });
          }
        },
        onContent: function onContent(e) {
          // detect that the button is clicked
          if (e.target && e.target.tagName === 'BUTTON') {
            _this.deleteCalled = true;
            fetch('/gd/rest/me/notifications/' + _this.config.type, {
              credentials: 'same-origin',
              method: 'DELETE'
            }).then(function () {
              return _this.callback({
                type: _this.config.type,
                action: 'click'
              });
            }).then(function (stopPropagation) {
              if (!stopPropagation) {
                location.href = _this.config.url || '/gd/s03.do?gametype=' + _this.config.gametype;
              }
            }).catch(function (err) {
              return void 0;
            });
          } else {
            // stop propagation will prevent toast from self closing
            e.stopPropagation();
          }
        }
      };
    }
    /**
     * Note: GD logo: gameLogo60x40
     * @returns
     */
  }, {
    key: "render",
    value: function render() {
      return "<div class=\"notifications-gameNight\">\n    <h3>".concat(this.t('notification.gameNight.title'), "</h3> \n      <div class=\"notifications-row\">\n        <div class=\"notifications-logo gameLogo60x40 game_").concat(this.config.gametype, "\"></div>\n        <div>\n          <p>").concat(this.t('notification.gameNight.text', {
        gameName: this.t("gameName.text.".concat(this.config.gametype))
      }), "</p>\n        </div>\n      </div>\n      <button class=\"colorButton\">").concat(this.t('notification.gameNight.button'), "</button></div>");
    }
  }]);
  return GameNight;
}();
;// CONCATENATED MODULE: ./node_modules/mitt/dist/mitt.mjs
/* harmony default export */ function mitt(n){return{all:n=n||new Map,on:function(t,e){var i=n.get(t);i?i.push(e):n.set(t,[e])},off:function(t,e){var i=n.get(t);i&&(e?i.splice(i.indexOf(e)>>>0,1):n.set(t,[]))},emit:function(t,e){var i=n.get(t);i&&i.slice().map(function(n){n(e)}),(i=n.get("*"))&&i.slice().map(function(n){n(t,e)})}}}
//# sourceMappingURL=mitt.mjs.map

;// CONCATENATED MODULE: ./node_modules/@gd/event-bus/dist/EventBus.js

var emitter = mitt();
emitter.once = function (type, fn) {
    emitter.on(type, fn);
    emitter.on(type, emitter.off.bind(emitter, type, fn));
};
var eventHandler = {
    $on: emitter.on,
    $once: emitter.once,
    $off: emitter.off,
    $emit: emitter.emit,
};
window.GD = window.GD || {};
// register hidden - it's bad practice when we register here directly
// to GD.event (registration on GD will be in the classic-gd module)
var eventBus = (window.GD.__eventBus = window.GD.__eventBus || eventHandler);
/* harmony default export */ var EventBus = (eventBus);
//# sourceMappingURL=EventBus.js.map
;// CONCATENATED MODULE: ./node_modules/@gd/event-bus/dist/index.js

/* harmony default export */ var event_bus_dist = ((/* unused pure expression or super */ null && (events)));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./src/lib/Notifications.ts























var Notifications = /*#__PURE__*/function () {
  function Notifications(options) {
    _classCallCheck(this, Notifications);
    _defineProperty(this, "options", void 0);
    _defineProperty(this, "defaultCallback", function () {
      return new Promise(function (res, rej) {
        return res(false);
      });
    });
    _defineProperty(this, "toast", void 0);
    this.toast = options.toast;
    this.options = options || {};
  }
  /**
   * Check URL params and execute the coresponding event. Returns true if something was found
   * @returns
   */
  _createClass(Notifications, [{
    key: "handleURLParams",
    value: function handleURLParams() {
      if (/redeemAvatar/.test(location.search)) {
        var itemId = new URLSearchParams(location.search).get('redeemAvatar');
        if (itemId) {
          EventBus.$emit('notifications', [{
            type: 'unlockAvatar',
            itemId: itemId
          }]);
          return true;
        }
      }
      return false;
    }
    /**
     * uses /gd/rest/me/notifications to fetch the notifications. Will either trigger a toast or emit
     * the "notifications" -event with specific options
     * @param vue
     */
  }, {
    key: "init",
    value: function init() {
      var _this = this;
      var storageGD = new dist_Storage().read(STORE_NAME.GD);
      if (storageGD.decisions.indexOf('fe-notifications-off') > -1) {
        // skip if deactivated
        return;
      }
      // skip the rest when checking URL params was success
      if (this.handleURLParams()) {
        return;
      }
      fetch('/gd/rest/me/notifications', {
        credentials: 'same-origin'
      }).then(function (res) {
        return res.json();
      }).then(function (list) {
        var eventItemList = list.map(function (item) {
          if (item.type === 'award') return new Award(item, _this.options.callback || _this.defaultCallback);else if (item.type === 'lowMoney') return new LowMoney(item, _this.options.callback || _this.defaultCallback);else if (item.type === 'newsletter') return new Newsletter(item, _this.options.callback || _this.defaultCallback);else if (item.type === 'gameNight') return new GameNight(item, _this.options.callback || _this.defaultCallback);
          return item;
        }).filter(function (item) {
          if (item.render) {
            var message = item;
            _this.toast.show(message.render(), message.toastOptions);
            if (_this.options.callback) {
              _this.options.callback({
                type: message.config.type,
                action: 'show'
              });
            }
            return false;
          }
          return true;
        });
        if (eventItemList.length > 0) {
          EventBus.$emit('notifications', eventItemList);
        }
      });
    }
  }]);
  return Notifications;
}();

;// CONCATENATED MODULE: ./src/main.ts

// required to generate the export


;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=notifications.common.js.map